{
	"dialog.ok": "OK",
	"dialog.cancel": "キャンセル",
	"dialog.confirm": "決定",
	"dialog.close": "閉じる",
	"dialog.import": "読み込み",
	"dialog.save": "保存",
	"dialog.discard": "保存しない",
	"dialog.dontshowagain": "次から表示しない",
	"data.cube": "キューブ",
	"data.group": "グループ",
	"data.texture": "テクスチャ",
	"data.plugin": "プラグイン",
	"data.preview": "プレビュー",
	"data.toolbar": "ツールバー",
	"data.image": "画像",
	"keys.ctrl": "Ctrl",
	"keys.shift": "Shift",
	"keys.alt": "Alt",
	"keys.meta": "Cmd",
	"keys.delete": "Delete",
	"keys.space": "Space",
	"keys.leftclick": "左クリック",
	"keys.middleclick": "ホイールクリック",
	"keys.rightclick": "右クリック",
	"keys.tab": "Tab",
	"keys.backspace": "Backspace",
	"keys.enter": "Enter",
	"keys.escape": "Escape",
	"keys.function": "F%0",
	"keys.numpad": "Numpad %0",
	"keys.caps": "Caps Lock",
	"keys.menu": "Context Menu",
	"keys.left": "Left",
	"keys.up": "Up",
	"keys.right": "Right",
	"keys.down": "Down",
	"keys.pageup": "Page Up",
	"keys.pagedown": "Page Down",
	"keys.plus": "Plus",
	"keys.comma": "Comma",
	"keys.point": "Point",
	"keys.minus": "Minus",
	"keys.cross": "Cross",
	"keys.end": "End",
	"keys.pos1": "Pos 1",
	"keys.printscreen": "Print Screen",
	"keys.pause": "Pause",
	"message.rotation_limit.title": "回転の制限",
	"message.rotation_limit.message": "Minecraft Java Block/Item では、ローテーションは一つの回転軸と 22.5 度刻みに制限されています。",
	"message.file_not_found.title": "ファイルが見つかりませんでした",
	"message.file_not_found.message": "ファイルが見つかりませんでした。ローカルディスクに保存されているか確認してください。",
	"message.screenshot.title": "スクリーンショット",
	"message.screenshot.clipboard": "クリップボード",
	"message.screenshot.right_click": "スクリーンショットを右クリックするか、長押ししてコピーできます",
	"message.invalid_file.title": "無効なファイル",
	"message.invalid_file.message": "モデルを開けませんでした：%0",
	"message.invalid_model.title": "無効なモデルファイル",
	"message.invalid_model.message": "このファイルには有効なモデルが含まれていません。",
	"message.child_model_only.title": "無効なモデル",
	"message.child_model_only.message": "このファイル %0 は、有効なモデルが含まれていません。",
	"message.unsaved_textures.title": "テクスチャが保存されていません",
	"message.unsaved_textures.message": "モデルに保存されていないテクスチャがあります。正しいフォルダに保存してください。",
	"message.model_clipping.title": "モデルが大きすぎます :(",
	"message.model_clipping.message": "3x3x3 ブロックサイズよりも大きいキューブが %0 個含まれています。このモデルは Minecraft では動作しません。",
	"message.loose_texture.title": "テクスチャを読み込み",
	"message.loose_texture.message": "読み込まれたテクスチャはリソースパックに含まれていません。Minecraft はテクスチャをリソースパックファイルからロードします。",
	"message.loose_texture.change": "パスを変更する",
	"message.update_res.title": "ピクセル数",
	"message.update_res.message": "テクスチャの解像度を統一しますか？ もし通常より高い解像度のテクスチャがある場合は、'キャンセル' を選択してください。",
	"message.update_res.update": "アップデート",
	"message.bedrock_overwrite_error.message": "古いファイルと組み合わせることができません",
	"message.bedrock_overwrite_error.backup_overwrite": "バックアップの作成と上書き",
	"message.bedrock_overwrite_error.overwrite": "上書き",
	"message.close_warning.message": "モデルを保存しますか？",
	"message.close_warning.web": "モデルが保存されていません。本当に終了しますか？",
	"message.default_textures.title": "デフォルトテクスチャ",
	"message.default_textures.message": "リソースパックの \"textures\" フォルダを選択します",
	"message.default_textures.detail": "Minecraft jar または Google からリソースパックをダウンロードします。次に \"textures\" フォルダを見つけて開きます。もし特に指定がない場合、Blockbench はそこからテクスチャを取得しようとします。",
	"message.default_textures.select": "\"textures\" フォルダを選択",
	"message.image_editor.title": "画像エディタを選択",
	"message.image_editor.file": "ファイルを選択...",
	"message.image_editor.exe": "使用可能な画像エディタを選択",
	"message.display_skin.title": "スキン",
	"message.display_skin.message": "ファイルからスキンを選択するか、Minecraft ID を入力してください",
	"message.display_skin.upload": "スキンをアップロード",
	"message.display_skin.reset": "リセット",
	"message.invalid_plugin": "無効なプラグインファイルです",
	"message.load_plugin_app": "このプラグインがコンピューターに変更を加えることを許可しますか？信頼できる作成者のプラグインのみをロードしてください。",
	"message.load_plugin_web": "このプラグインをロードしますか？ 信頼できる作成者のプラグインのみをロードしてください。",
	"message.preset_no_info": "プリセットにはスロット情報が含まれていません",
	"message.restart_to_update": "変更を適用するために、Blockbench を再起動します",
	"message.save_file": "%0 を保存しました",
	"dialog.project.title": "プロジェクト",
	"dialog.project.name": "プロジェクト名",
	"dialog.project.parent": "親モデル",
	"dialog.project.geoname": "拡張子",
	"dialog.project.ao": "Ambient Occlusion",
	"dialog.texture.title": "テクスチャ",
	"dialog.texture.variable": "変数",
	"dialog.texture.namespace": "ネームスペース",
	"dialog.texture.folder": "フォルダ",
	"dialog.extrude.title": "画像の押し出し",
	"dialog.extrude.mode": "スキャンモード",
	"dialog.extrude.mode.areas": "エリア",
	"dialog.extrude.mode.lines": "行",
	"dialog.extrude.mode.columns": "列",
	"dialog.extrude.mode.pixels": "ピクセル",
	"dialog.extrude.opacity": "最小透明度",
	"dialog.extrude.scan": "スキャンと読み込み",
	"dialog.display_preset.title": "プリセットの設定",
	"dialog.display_preset.message": "保存するスロットを選択してください",
	"dialog.display_preset.create": "作成する",
	"dialog.select.title": "選択する",
	"dialog.select.group": "選択されたグループ",
	"dialog.select.name": "名前に含まれる",
	"dialog.select.random": "ランダムチャンス (%)",
	"dialog.select.select": "選択する",
	"dialog.scale.title": "サイズを変更",
	"dialog.scale.axis": "軸",
	"dialog.scale.clipping": "モデルクリップ：モデルがキャンバスに対して大きすぎます",
	"dialog.scale.confirm": "決定",
	"dialog.plugins.title": "プラグイン",
	"dialog.plugins.installed": "インストール済み",
	"dialog.plugins.available": "利用可能",
	"dialog.plugins.install": "インストール",
	"dialog.plugins.uninstall": "アンインストール",
	"dialog.plugins.reload": "リロード",
	"dialog.plugins.none_installed": "プラグインがインストールされていません",
	"dialog.plugins.none_available": "利用可能なプラグインはありません",
	"dialog.plugins.web_only": "ウェブアプリのみ",
	"dialog.plugins.app_only": "デスクトップアプリのみ",
	"dialog.plugins.author": "%0",
	"dialog.create_texture.folder": "フォルダ",
	"dialog.create_texture.resolution": "ピクセル",
	"dialog.input.title": "インプット",
	"dialog.settings.settings": "設定",
	"dialog.settings.keybinds": "キーバインド",
	"dialog.settings.about": "About",
	"layout.color.back": "フィールド",
	"layout.color.back.desc": "背景と入力フィールド",
	"layout.color.dark": "キャンバス",
	"layout.color.dark.desc": "キャンバスの背景",
	"layout.color.ui": "UI",
	"layout.color.ui.desc": "メインインターフェイス",
	"layout.color.bright_ui": "ライトUI",
	"layout.color.bright_ui.desc": "コンテキストメニューとツールチップ",
	"layout.color.button": "ボタン",
	"layout.color.button.desc": "ボタンとスイッチ",
	"layout.color.selected": "ハイライト",
	"layout.color.selected.desc": "選択されたタブとオブジェクト",
	"layout.color.border": "ボーダー",
	"layout.color.border.desc": "ボタンと入力の境界",
	"layout.color.accent": "アクセント",
	"layout.color.accent.desc": "スライダーとその他の詳細",
	"layout.color.grid": "グリッド",
	"layout.color.grid.desc": "3D プレビューグリッド",
	"layout.color.text": "テキスト",
	"layout.color.text.desc": "ノーマルテキスト",
	"layout.color.light": "ライトテキスト",
	"layout.color.light.desc": "ハイライトテキスト",
	"layout.color.accent_text": "アクセントテキスト",
	"layout.color.accent_text.desc": "アクセントの背景のテキスト",
	"layout.font.main": "メインフォント",
	"layout.font.headline": "見出しフォント",
	"about.version": "バージョン：",
	"settings.category.general": "一般",
	"settings.category.preview": "プレビュー",
	"settings.category.grid": "グリッド",
	"settings.category.edit": "エディット",
	"settings.category.snapping": "スナップ",
	"settings.category.defaults": "デフォルト",
	"settings.category.dialogs": "ダイアログ",
	"settings.category.export": "書き出し",
	"settings.language": "言語を変更",
	"settings.language.desc": "インターフェース言語",
	"settings.backup_interval": "バックアップ",
	"settings.backup_interval.desc": "バックアップの頻度を変更します",
	"settings.origin_size": "ピボットマーカー",
	"settings.origin_size.desc": "ピボットマーカーのサイズを設定します",
	"settings.control_size": "ギズモサイズ",
	"settings.control_size.desc": "ギズモのサイズを設定します",
	"settings.display_skin": "スキンを表示",
	"settings.display_skin.desc": "ディスプレイモデルに使用されるスキンを変更します",
	"settings.shading": "シェーディング",
	"settings.shading.desc": "シェーディングを有効にします",
	"settings.texture_fps": "アニメーション FPS",
	"settings.texture_fps.desc": "アニメーションテクスチャのフレームレートを設定します",
	"settings.base_grid": "スモールグリッド",
	"settings.base_grid.desc": "スモールグリッドを表示します",
	"settings.large_grid": "ブロックグリッド",
	"settings.large_grid.desc": "ブロックサイズのグリッドを表示します",
	"settings.full_grid": "ピクセルグリッド",
	"settings.full_grid.desc": "1 ピクセルの最小グリッドを表示します",
	"settings.large_box": "リミットグリット",
	"settings.large_box.desc": "3×3×3 のブロックボーダーを表示します",
	"settings.display_grid": "ディスプレイモード",
	"settings.display_grid.desc": "ディスプレイモードでグリッドを表示します",
	"settings.undo_limit": "取り消し",
	"settings.undo_limit.desc": "取り消しステップの最大数を設定します",
	"settings.local_move": "相対軸上を移動",
	"settings.local_move.desc": "回転した要素を独自の軸上で移動します",
	"settings.canvas_unselect": "キャンパスクリア",
	"settings.canvas_unselect.desc": "背景をクリックすると、すべての選択が解除されます",
	"settings.paint_side_restrict": "マスキングテープ",
	"settings.paint_side_restrict.desc": "選択されたフェイスのみにペイントします",
	"settings.autouv": "オート UV",
	"settings.autouv.desc": "オート UV を有効にします",
	"settings.create_rename": "エレメントのリネーム",
	"settings.create_rename.desc": "新しいエレメントを作成する際に名前フィールドがフォーカスされます",
	"settings.edit_size": "グリッドステップ",
	"settings.edit_size.desc": "キューブのグリッド間隔を変更します",
	"settings.shift_size": "Shift ステップ",
	"settings.shift_size.desc": "shift キーのグリッド間隔を変更します",
	"settings.ctrl_size": "Ctrl ステップ",
	"settings.ctrl_size.desc": "control キーのグリッド間隔を変更します",
	"settings.negative_size": "マイナスサイズ",
	"settings.negative_size.desc": "キューブが負のサイズを使用できるようにします",
	"settings.minifiedout": "書き出しを最小化",
	"settings.minifiedout.desc": "JSON ファイルを 1 行で記述します",
	"settings.export_groups": "グループの書き出し",
	"settings.export_groups.desc": "グループをモデルファイルに保存します",
	"settings.credit": "クレジット",
	"settings.credit.desc": "モデルにクレジットコメントを追加します",
	"settings.default_path": "デフォルトテクスチャパス",
	"settings.default_path.desc": "Blockbench がテクスチャをロードするフォルダを設定します",
	"settings.image_editor": "画像エディタ",
	"settings.image_editor.desc": "使用可能な画像エディタを選択します",
	"category.navigate": "ナビゲーション",
	"category.tools": "ツール",
	"category.file": "ファイル",
	"category.blockbench": "Blockbench",
	"category.edit": "Edit",
	"category.transform": "変換",
	"category.view": "ビュー",
	"category.display": "ディスプレイ設定",
	"category.textures": "テクスチャ",
	"category.misc": "その他",
	"keybind.preview_select": "選択",
	"keybind.preview_rotate": "回転ビュー",
	"keybind.preview_drag": "ドラッグビュー",
	"keybind.confirm": "確認",
	"keybind.cancel": "キャンセル",
	"action.slider_inflate": "インフレート",
	"action.slider_inflate.desc": "UV を変更せずにキューブを膨らませます",
	"action.slider_brush_size": "サイズ",
	"action.slider_brush_size.desc": "ブラシの半径",
	"action.slider_brush_opacity": "透明度",
	"action.slider_brush_opacity.desc": "ブラシの透明度",
	"action.slider_brush_softness": "ソフトネス",
	"action.slider_brush_softness.desc": "ブラシの柔らかさ",
	"action.uv_slider_pos_x": "水平移動",
	"action.uv_slider_pos_x.desc": "選択したキューブの UV を水平方向に移動します",
	"action.uv_slider_pos_y": "垂直移動",
	"action.uv_slider_pos_y.desc": "選択したキューブの UV を垂直方向に移動します",
	"action.uv_slider_size_x": "水平サイズ",
	"action.uv_slider_size_x.desc": "選択した UV を水平方向にリサイズします",
	"action.uv_slider_size_y": "垂直サイズ",
	"action.uv_slider_size_y.desc": "選択した UV を垂直方向にリサイズします",
	"action.vertex_snap_mode": "スナップ",
	"action.vertex_snap_mode.desc": "頂点スナップが選択された位置に移動するか、サイズを変更するかを選択します",
	"action.move_tool": "移動",
	"action.move_tool.desc": "エレメントを選択して移動します",
	"action.resize_tool": "サイズ",
	"action.resize_tool.desc": "エレメントを選択してサイズを変更します",
	"action.brush_tool": "ブラシ",
	"action.brush_tool.desc": "テクスチャを描くためのカラーブラシ",
	"action.vertex_snap_tool": "スナップ",
	"action.vertex_snap_tool.desc": "２つのブロックの頂点を接続します",
	"action.swap_tools": "スワップ",
	"action.swap_tools.desc": "移動ツールとサイズツールを切り替えます",
	"action.project_window": "プロジェクト...",
	"action.project_window.desc": "モデルのメタデータを編集するウィンドウを開きます",
	"action.open_model": "モデルを開く",
	"action.open_model.desc": "コンピュータからモデルファイルを開きます",
	"action.extrude_texture": "テクスチャの押し出し",
	"action.extrude_texture.desc": "テクスチャを引き延ばしてモデルを作成します",
	"action.export_blockmodel": "Json Model",
	"action.export_blockmodel.desc": "Minecraft Block/Item モデルを書き出します",
	"action.export_optifine_part": "OptiFine Part",
	"action.export_optifine_part.desc": "OptiFine エンティティパーツを書き出します",
	"action.export_optifine_full": "OptiFine JEM",
	"action.export_optifine_full.desc": "OptiFine エンティティモデルを書き出します",
	"action.export_obj": "OBJ Model",
	"action.export_obj.desc": "Wavefront OBJ モデルを書き出します",
	"action.settings_window": "設定...",
	"action.settings_window.desc": "Blockbench 環境設定を開きます。",
	"action.plugins_window": "プラグイン...",
	"action.plugins_window.desc": "プラグインストアを開きます",
	"action.reset_layout": "レイアウトをリセット",
	"action.reset_layout.desc": "レイアウト設定をデフォルトに戻します",
	"action.load_plugin": "プラグインを開く",
	"action.load_plugin.desc": "ソースファイルからプラグインをロードします",
	"action.reload_plugins": "プラグインをリロード",
	"action.reload_plugins.desc": "すべてのプラグインをリロードします",
	"action.undo": "戻す",
	"action.undo.desc": "最後の変更を巻き戻します",
	"action.redo": "進む",
	"action.redo.desc": "最後の変更を元に戻します",
	"action.copy": "コピー",
	"action.copy.desc": "選択したフェイス、または設定をコピーします",
	"action.paste": "ペースト",
	"action.paste.desc": "選択したフェイス、または設定をペーストします",
	"action.cut": "カット",
	"action.cut.desc": "選択したフェイス、または設定をカットします",
	"action.add_cube": "キューブを追加",
	"action.add_cube.desc": "新しいキューブを追加します",
	"action.add_group": "グループを追加",
	"action.add_group.desc": "新しいグループを追加します",
	"action.outliner_toggle": "その他のオプション",
	"action.outliner_toggle.desc": "アウトラインのオプションを切り替えます",
	"action.duplicate": "複製",
	"action.duplicate.desc": "選択したキューブ、またはグループを複製します",
	"action.delete": "削除",
	"action.delete.desc": "選択したキューブ、またはグループを削除します",
	"action.sort_outliner": "ソート",
	"action.sort_outliner.desc": "アウトラインをアルファベット順に並び替えます",
	"action.select_window": "セレクト...",
	"action.select_window.desc": "プロパティからエレメントを検索します",
	"action.invert_selection": "インバート",
	"action.invert_selection.desc": "選択中のエレメントを反転します",
	"action.select_all": "すべて選択",
	"action.select_all.desc": "すべてのエレメントを選択します",
	"action.collapse_groups": "折りたたむ",
	"action.collapse_groups.desc": "すべてのグループを折りたたみます",
	"action.scale": "スケール...",
	"action.scale.desc": "選択したエレメントを拡大・縮小します",
	"action.toggle_visibility": "可視化",
	"action.toggle_visibility.desc": "選択したエレメントの表示を切り替えます",
	"action.toggle_export": "書き出し",
	"action.toggle_export.desc": "選択したエレメントの書き出し設定を切り替えます",
	"action.toggle_autouv": "オート UV",
	"action.toggle_autouv.desc": "オート UV 設定を切り替えます",
	"action.toggle_shade": "シェーディング",
	"action.toggle_shade.desc": "選択したキューブのシェードを切り替えます",
	"action.rename": "名前を変更",
	"action.rename.desc": "選択したエレメントの名前を変更します",
	"action.add_display_preset": "プリセットの設定",
	"action.add_display_preset.desc": "新しいディスプレイ設定を追加します",
	"action.fullscreen": "フルスクリーン",
	"action.fullscreen.desc": "フルスクリーンで表示します",
	"action.zoom_in": "ズームイン",
	"action.zoom_in.desc": "インターフェイスを拡大します",
	"action.zoom_out": "ズームアウト",
	"action.zoom_out.desc": "インターフェイスを縮小します",
	"action.zoom_reset": "リセット",
	"action.zoom_reset.desc": "ズーム設定をリセットします",
	"action.reset_interface": "インターフェイスをリセット",
	"action.reset_interface.desc": "GUI インターフェイスをリセットします",
	"action.screenshot_model": "モデルショット",
	"action.screenshot_model.desc": "モデルのスクリーンショットを撮ります",
	"action.screenshot_app": "アプリショット",
	"action.screenshot_app.desc": "アプリケーション全体のスクリーンショットを撮ります",
	"action.import_texture": "テクスチャを読み込み",
	"action.import_texture.desc": "ファイルからテクスチャを読み込みます",
	"action.create_texture": "新規作成",
	"action.create_texture.desc": "テクスチャまたはテンプレートテクスチャを作成します",
	"action.save_textures": "保存",
	"action.save_textures.desc": "すべてのテクスチャを保存します",
	"action.animated_textures": "アニメーションを再生",
	"action.animated_textures.desc": "アニメーションテクスチャを再生します",
	"action.origin_to_geometry": "センターピボット",
	"action.origin_to_geometry.desc": "ピボットを選択範囲の中心に設定します",
	"action.rescale_toggle": "リスケール",
	"action.rescale_toggle.desc": "ローテーションをベースにサイズを変更します",
	"action.bone_reset_toggle": "ボーンリセット",
	"action.bone_reset_toggle.desc": "親モデルのボーンを表示しないようにします",
	"action.reload": "Blockbench をリロード",
	"action.reload.desc": "Blockbench をリロードします。保存されていない変更は失われます",
	"menu.file": "File",
	"menu.edit": "Edit",
	"menu.transform": "Transform",
	"menu.display": "Display",
	"menu.view": "View",
	"menu.file.new": "新規作成",
	"menu.file.recent": "最近開いたモデル",
	"menu.file.import": "読み込み",
	"menu.file.export": "書き出し",
	"menu.transform.rotate": "回転",
	"menu.transform.flip": "フリップ",
	"menu.transform.center": "センター",
	"menu.transform.properties": "プロパティ",
	"menu.display.preset": "プリセットを適用",
	"menu.display.preset_all": "すべてのプリセットを適用",
	"menu.display.remove_preset": "プリセットを削除",
	"menu.view.zoom": "ズーム",
	"menu.view.background": "背景",
	"menu.view.screenshot": "スクリーンショット",
	"menu.cube.color": "カラー",
	"menu.cube.texture": "テクスチャ",
	"menu.cube.texture.transparent": "非表示",
	"menu.cube.texture.blank": "リセット",
	"menu.group.sort": "ソート",
	"menu.texture.face": "フェイスに適用",
	"menu.texture.file": "ファイル",
	"menu.texture.refresh": "更新",
	"menu.texture.change": "ファイルを変更",
	"menu.texture.folder": "フォルダから開く",
	"menu.texture.edit": "編集",
	"menu.texture.export": "保存",
	"menu.texture.save": "上書き",
	"menu.texture.properties": "プロパティ...",
	"menu.preview.background": "背景",
	"menu.preview.background.load": "ロード",
	"menu.preview.background.position": "ポジション",
	"menu.preview.background.lock": "カメラを固定",
	"menu.preview.screenshot": "スクリーンショット",
	"menu.preview.perspective": "パースペクティブ",
	"menu.preview.perspective.normal": "ノーマル",
	"menu.preview.quadview": "クワッドビュー",
	"menu.preview.stop_drag": "背景を固定する",
	"menu.uv.mapping.rotation": "ローテーション",
	"menu.uv.texture": "テクスチャ",
	"cube.color.light_blue": "シアン",
	"cube.color.yellow": "イエロー",
	"cube.color.orange": "オレンジ",
	"cube.color.red": "レッド",
	"cube.color.purple": "パープル",
	"cube.color.blue": "ブルー",
	"cube.color.green": "グリーン",
	"cube.color.lime": "ライム",
	"switches.visibility": "可視化",
	"switches.export": "書き出し",
	"switches.autouv": "オート UV",
	"panel.uv": "UV",
	"panel.display": "Display",
	"panel.textures": "Textures",
	"panel.outliner": "Outliner",
	"uv_editor.title": "UV Editor",
	"uv_editor.all_faces": "All",
	"uv_editor.no_faces": "None",
	"face.north": "North",
	"face.south": "South",
	"face.west": "West",
	"face.east": "East",
	"face.up": "Up",
	"face.down": "Down",
	"direction.north": "North",
	"direction.south": "South",
	"direction.west": "West",
	"direction.east": "East",
	"direction.top": "Top",
	"direction.bottom": "Bottom",
	"display.slot.third_right": "右手",
	"display.slot.third_left": "左手",
	"display.slot.first_right": "右手",
	"display.slot.first_left": "左手",
	"display.slot.head": "帽子",
	"display.slot.ground": "ドロップ",
	"display.slot.frame": "額縁",
	"display.slot.gui": "GUI",
	"display.rotation": "Rotation",
	"display.translation": "Position",
	"display.scale": "Scale",
	"display.slot": "Slot",
	"display.reference": "Reference",
	"display.reference.player": "プレイヤー",
	"display.reference.zombie": "ゾンビ",
	"display.reference.armor_stand": "アーマースタンド",
	"display.reference.baby_zombie": "子供ゾンビ",
	"display.reference.armor_stand_small": "ミニアーマースタンド",
	"display.reference.monitor": "ノーマル",
	"display.reference.bow": "弓",
	"display.reference.block": "ブロック",
	"display.reference.frame": "額縁",
	"display.reference.inventory_nine": "作業台",
	"display.reference.inventory_full": "インベントリ",
	"display.reference.hud": "HUD",
	"display.preset.blank_name": "名前を入力してください",
	"display.preset.item": "アイテム",
	"display.preset.block": "ブロック",
	"display.preset.handheld": "ツール",
	"display.preset.rod": "釣竿",
	"dialog.continue": "続ける",
	"message.square_textures": "テクスチャは正方形でなければ適用出来ません",
	"message.unsaved_texture.title": "保存されてないテクスチャ",
	"message.unsaved_texture.message": "テクスチャは保存されずに失われます。続行しますか？",
	"action.vertex_snap_mode.move": "Move",
	"action.vertex_snap_mode.scale": "Scale",
	"action.open_model_folder": "モデルフォルダを開く",
	"action.open_model_folder.desc": "モデルフォルダを開きます",
	"action.change_textures_folder": "テクスチャフォルダを変更",
	"action.change_textures_folder.desc": "テクスチャが保存されているフォルダを変更します",
	"menu.texture.particle": "パーティクル",
	"message.update_notification.title": "アップデートをインストールできませんでした :(",
	"message.update_notification.message": "新しい Blockbench バージョンが利用可能です。更新するには自動更新を有効にしてください！",
	"message.untextured": "テクスチャを見つけることができませんでした",
	"dialog.toolbar_edit.title": "ツールバーのカスタマイズ",
	"keybindings.reset": "リセット",
	"keybindings.clear": "クリア",
	"action.cube_counter": "モデル統計",
	"action.uv_rotation": "ローテーション UV",
	"action.uv_rotation.desc": "UV を回転します",
	"action.uv_grid": "グリット UV",
	"action.uv_grid.desc": "UV のグリッド間隔",
	"action.uv_grid.auto": "オート",
	"action.uv_maximize": "フル UV",
	"action.uv_maximize.desc": "この UV をフルテクスチャに設定します",
	"action.uv_auto": "オート UV",
	"action.uv_auto.desc": "このフェイス UV を実際の大きさに設定します",
	"action.uv_rel_auto": "リバースオート UV",
	"action.uv_rel_auto.desc": "このフェイス UV を実際の位置と大きさに設定します",
	"action.uv_mirror_x": "UV Mirror X",
	"action.uv_mirror_x.desc": "UV を X 軸にミラーリングします",
	"action.uv_mirror_y": "UV Mirror Y",
	"action.uv_mirror_y.desc": "UV を Y 軸にミラーリングします",
	"action.uv_transparent": "削除",
	"action.uv_transparent.desc": "現在のフェイスを削除します",
	"action.uv_reset": "リセット",
	"action.uv_reset.desc": "フェイスをリセットします",
	"action.cullface": "カリング",
	"action.cullface.desc": "選択されたブロックが他のブロックと接触した場合、そのフェイスを描画しないようにします",
	"action.auto_cullface": "カリングを有効",
	"action.auto_cullface.desc": "カリングを自動に設定します",
	"action.face_tint": "ティント",
	"action.face_tint.desc": "現在のフェイス色合いオプションを有効にします",
	"menu.toolbar.edit": "カスタマイズ",
	"menu.toolbar.reset": "リセット",
	"uv_editor.rotated": "ローテーション",
	"uv_editor.auto_cull": "カリングを手動にする",
	"uv_editor.copied": "コピー",
	"uv_editor.pasted": "ペースト",
	"uv_editor.copied_x": "%0 をコピー",
	"uv_editor.reset": "フェイスをリセット",
	"uv_editor.maximized": "フル",
	"uv_editor.autouv": "オートサイズ",
	"uv_editor.mirrored": "ミラーリング",
	"uv_editor.to_all": "すべてのフェイスに適用",
	"uv_editor.transparent": "透明",
	"uv_editor.cullface_on": "カリング ON",
	"uv_editor.cullface_off": "カリング OFF",
	"uv_editor.tint_on": "ティント ON",
	"uv_editor.tint_off": "ティント OFF",
	"action.uv_apply_all": "すべてのフェイスに適用",
	"action.uv_apply_all.desc": "すべてのフェイスに適用します",
	"message.image_editor_missing.title": "デフォルト画像エディタ",
	"message.image_editor_missing.message": "使用可能な画像エディタを選択します。",
	"message.image_editor_missing.detail": "画像エディタを見つけることができませんでした。お好みの画像エディタの実行可能ファイルを選択します。",
	"action.update_autouv": "オート UV",
	"action.update_autouv.desc": "オート UV を更新します",
	"category.uv": "UV",
	"status_bar.saved": "モデルを保存しました",
	"status_bar.unsaved": "変更が保存されていません",
	"action.move_up": "Move Up",
	"action.move_up.desc": "選択したキューブを上に移動します",
	"action.move_down": "Move Down",
	"action.move_down.desc": "選択したキューブを下に移動します",
	"action.move_left": "Move Left",
	"action.move_left.desc": "選択したキューブを左に移動します",
	"action.move_right": "Move Right",
	"action.move_right.desc": "選択したキューブを右に移動します",
	"action.move_forth": "Move Forth",
	"action.move_forth.desc": "選択したキューブを前方に移動します",
	"action.move_back": "Move Back",
	"action.move_back.desc": "選択したキューブを後方に移動します",
	"layout.color.wireframe": "ワイヤーフレーム",
	"layout.color.wireframe.desc": "ワイヤーフレームビュー",
	"action.add_animation": "アニメーションを追加",
	"action.add_animation.desc": "新規アニメーションを追加します",
	"action.load_animation_file": "アニメーションを読み込み",
	"action.load_animation_file.desc": "アニメーションファイルを読み込みます",
	"action.play_animation": "アニメーションを再生",
	"action.play_animation.desc": "選択したアニメーションを再生します",
	"action.slider_keyframe_time": "タイムコード",
	"action.slider_keyframe_time.desc": "選択したキーフレームのタイムコードを変更します",
	"timeline.rotation": "ローテーション",
	"timeline.position": "ポジション",
	"timeline.scale": "スケール",
	"menu.keyframe.quaternion": "クォータニオン",
	"panel.animations": "Animations",
	"panel.keyframe": "Keyframe",
	"panel.keyframe.type": "Keyframe (%0)",
	"generic.delete": "削除",
	"generic.rename": "名前を変更",
	"message.no_animation_selected": "アニメーションを選択してください",
	"message.no_bone_selected": "これを行うにはボーンを選択する必要があります",
	"message.duplicate_groups.title": "ボーン名が重複しています",
	"message.duplicate_groups.message": "この名前はすでに使用されています。別の名前を選択してください。",
	"action.delete_keyframes": "キーフレームを削除",
	"action.delete_keyframes.desc": "選択したすべてのキーフレームを削除します",
	"menu.animation": "Animation",
	"menu.animation.loop": "ループモード",
	"menu.animation.override": "オーバーライド",
	"menu.animation.anim_time_update": "タイムアップデート",
	"message.display_skin_model.title": "スキン",
	"message.display_skin_model.message": "スキンタイプを選択します",
	"message.display_skin_model.classic": "クラシック",
	"message.display_skin_model.slim": "スリム",
	"message.bone_material": "ボーンのマテリアルを変更します",
	"action.slider_animation_length": "アニメーションフィート",
	"action.slider_animation_length.desc": "選択したアニメーションの長さを変更します",
	"panel.variable_placeholders": "Placeholders",
	"panel.variable_placeholders.info": "List the variables placeholders",
	"status_bar.vertex_distance": "ディスタンス：%0",
	"dialog.create_gif.title": "GIF",
	"dialog.create_gif.length": "尺",
	"dialog.create_gif.fps": "FPS",
	"dialog.create_gif.play": "アニメーションを再生",
	"category.animation": "Animation",
	"action.record_model_gif": "レコーディング GIF...",
	"action.record_model_gif.desc": "現在の角度からモデルのアニメーション GIF を記録します",
	"display.mirror": "Mirror",
	"data.separator": "セパレータ",
	"menu.preview.background.set_position": "位置をセット",
	"dialog.toolbar_edit.hidden": "隠す",
	"action.export_class_entity": "Java Entity",
	"action.export_class_entity.desc": "エンティティモデルを Java class として書き出します",
	"settings.seethrough_outline": "X-Rey アウトライン",
	"settings.seethrough_outline.desc": "オブジェクトを通してアウトラインを表示します",
	"mode.edit": "Edit",
	"mode.paint": "Paint",
	"mode.display": "Display",
	"mode.animate": "Animate",
	"status_bar.recording_gif": "レコーディング",
	"status_bar.processing_gif": "加工処理",
	"settings.backup_retain": "バックアップ保持期間",
	"settings.backup_retain.desc": "バックアップを保持する日数を設定します",
	"action.rotate_tool": "回転",
	"action.rotate_tool.desc": "選択中のエレメントを回転させることができます",
	"action.fill_tool": "バケツ",
	"action.fill_tool.desc": "選択欄を塗りつぶすことができます",
	"action.eraser": "消しゴム",
	"action.eraser.desc": "テクスチャの色を消去できます",
	"action.color_picker": "ピッカー",
	"action.color_picker.desc": "テクスチャの色を選択できます",
	"switches.mirror": "Mirror UV",
	"language_name": "日本語",
	"message.plugin_reload": "プラグイン %0 をリロードしました",
	"settings.brightness": "明るさ",
	"settings.brightness.desc": "プレビューの明るさを変更します。初期値５０",
	"menu.preview.perspective.reset": "カメラをリセット",
	"action.fill_mode": "塗りつぶし",
	"action.fill_mode.face": "フェイス",
	"action.fill_mode.color": "カラー",
	"action.toggle_mirror_uv": "Mirror UV",
	"action.toggle_mirror_uv.desc": "選択したキューブの UV ミラーリングを切り替えます",
	"menu.texture.blank": "テクスチャのないフェイスに適用",
	"dialog.scale.select_overflow": "オーバーフローを選択",
	"action.action_control": "アクションコントロール",
	"action.action_control.desc": "利用可能なアクションを検索します",
	"keybindings.recording": "キー設定を記録",
	"keybindings.press": "画面上の任意の場所をクリックして、キーを記録します。",
	"action.pivot_tool": "ピボットツール",
	"action.pivot_tool.desc": "エレメントのピボットポイントを変更します",
	"action.slider_animation_speed": "再生スピード",
	"action.slider_animation_speed.desc": "タイムラインの再生速度を変更します",
	"action.previous_keyframe": "キーフレームを戻す",
	"action.previous_keyframe.desc": "前のキーフレームにジャンプ",
	"action.next_keyframe": "キーフレームを進める",
	"action.next_keyframe.desc": "次のキーフレームにジャンプ",
	"message.outdated_client.title": "旧バージョン",
	"message.outdated_client.message": "これを実行するには、Blockbench を最新バージョンにアップデートして下さい。",
	"action.export_asset_archive": "アーカイブからダウンロード",
	"action.export_asset_archive.desc": "アーカイブからモデルをダウンロードします",
	"action.upload_sketchfab": "Sketchfabにアップロード...",
	"message.sketchfab.name_or_token": "Sketchfab の Token と名前を入力して下さい",
	"dialog.sketchfab_uploader.title": "Sketchfab モデルをアップロード",
	"dialog.sketchfab_uploader.token": "API Token",
	"dialog.sketchfab_uploader.about_token": "Token は Blockbench が Sketchfab アカウントに接続するのに使用されます。%0 から探すことができます",
	"dialog.sketchfab_uploader.name": "題名",
	"dialog.sketchfab_uploader.description": "詳細",
	"dialog.sketchfab_uploader.tags": "タグ",
	"settings.sketchfab_token": "Sketchfab Token",
	"settings.sketchfab_token.desc": "Blockbench に Sketchfab アカウントへのアップロードを許可します",
	"panel.color": "Color",
	"data.origin": "ピボット",
	"message.sketchfab.success": "モデルのアップロードに成功しました",
	"message.sketchfab.error": "Sketchfab アップロードに失敗しました :(",
	"settings.outliner_colors": "アウトラインカラー",
	"settings.outliner_colors.desc": "アウトラインにキューブカラーを表示します",
	"action.upload_sketchfab.desc": "Sketchfab にモデルをアップロード",
	"action.element_colors": "Cube Colors",
	"action.element_colors.desc": "Outliner でキューブカラーを表示します",
	"texture.error.file": "ファイルが見つかりません",
	"texture.error.parent": "親モデルによって提供されたテクスチャファイル",
	"message.recover_backup.title": "モデルを復元",
	"message.recover_backup.message": "Blockbench は保存できずに終了しました。モデルを復元しますか？",
	"message.invalid_session.title": "無効なセッション Token",
	"message.invalid_session.message": "このセッションは無効です。",
	"dialog.create_texture.power": "正方サイズ",
	"dialog.create_gif.turn": "ターンテーブルスピード",
	"action.edit_session": "セッションを編集...",
	"action.edit_session.desc": "他のクリエイターとセッションを通して共同制作ができます",
	"action.reset_keyframe": "キーフレームを削除する",
	"action.reset_keyframe.desc": "選択したキー設定をすべてリセットします",
	"dialog.edit_session.title": "セッションを編集",
	"edit_session.username": "ユーザーネーム",
	"edit_session.token": "Token",
	"edit_session.about": "編集セッションを使用して、インターネット全体のモデルで共同作業を行えます。トークンをコピーして、フレンドに送信してください。",
	"edit_session.join": "セッションに参加",
	"edit_session.create": "セッションを作成",
	"edit_session.quit": "セッションから退出",
	"edit_session.joined": "%0 がセッションに参加しました",
	"edit_session.left": "%0 が退出しました",
	"edit_session.quit_session": "現在のセッションを終了しました",
	"edit_session.status": "ステータス",
	"edit_session.hosting": "ハウジング",
	"edit_session.connected": "セッションに接続する",
	"dialog.sketchfab_uploader.private": "プライベート (Pro)",
	"dialog.sketchfab_uploader.password": "パスワード (Pro)",
	"action.uv_select_all": "Select All",
	"action.uv_select_all.desc": "UV ダイアログでフェイスを選択します",
	"panel.chat": "Chat",
	"edit_session.welcome": "セッション %0 へようこそ！",
	"dialog.yes": "Yes",
	"dialog.no": "No",
	"generic.remove": "削除",
	"generic.download": "ダウンロード",
	"generic.search": "検索",
	"dates.today": "今日",
	"dates.yesterday": "昨日",
	"dates.this_week": "今週",
	"dates.weeks_ago": "%0 週間前",
	"mode.start.new": "新規作成",
	"mode.start.recent": "最近開いたモデル",
	"format.free": "Generic Model",
	"format.free.desc": "ゲームエンジンやレンダリングなど、無制限のモデリングフォーマット",
	"format.java_block": "Java Block/Item",
	"format.java_block.desc": "Minecraft Java Edition ブロック/アイテム",
	"format.bedrock": "Bedrock Entity",
	"format.bedrock.desc": "Minecraft Bedrock Edition のエンティティおよびアタッチ可能なアイテムのモデル",
	"format.bedrock_old": "Bedrock Legacy Model",
	"format.bedrock_old.desc": "Pre-1.12  Minecraft Bedrock Edition エンティティモデル",
	"format.modded_entity": "Modded Entity",
	"format.modded_entity.desc": "Minecraft Mods エンティティモデル",
	"format.optifine_entity": "OptiFine Entity",
	"format.optifine_entity.desc": "OptiFine カスタムエンティティモデル",
	"keys.mouse": "マウスボタン %0",
	"message.cleared_blank_faces.title": "ブランクフェイス",
	"message.cleared_blank_faces.message": "%0 個のブランクフェイスを発見しました。それらをすべて削除しますか？",
	"message.wireframe.enabled": "ワイヤーフレームを有効にしました",
	"message.wireframe.disabled": "ワイヤーフレームを無効にしました",
	"dialog.convert_project.title": "プロジェクトを変換",
	"dialog.create_texture.double_use": "マルチテクスチャをキープする",
	"dialog.model_stats.title": "モデルステータス",
	"dialog.model_stats.cubes": "キューブ",
	"dialog.model_stats.locators": "ロケーター",
	"dialog.model_stats.groups": "グループ",
	"dialog.model_stats.vertices": "頂点",
	"dialog.model_stats.faces": "フェイス",
	"settings.username": "ニックネーム",
	"settings.username.desc": "セッションのニックネームを編集します",
	"settings.painting_grid": "ペイントグリット",
	"settings.painting_grid.desc": "ペイントモードでキューブにグリットを表示します",
	"action.convert_project": "プロジェクトを変換",
	"action.convert_project.desc": "別のモデルフォーマットに変換します",
	"action.close_project": "プロジェクトを閉じる",
	"action.close_project.desc": "進行中のプロジェクトを閉じます",
	"action.export_bedrock": "Bedrock Geometry",
	"action.export_bedrock.desc": "モデルを統合版ファイルとして書き出します。",
	"action.save_project": "プロジェクトを保存",
	"action.save_project.desc": "進行中のプロジェクトを保存します",
	"action.save_project_as": "名前を付けて保存",
	"action.save_project_as.desc": "進行中のすべてのプロジェクトを保存します",
	"action.export_over": "上書き保存",
	"action.export_over.desc": "ファイルを上書き保存します",
	"action.add_locator": "ロケータ－を追加",
	"action.add_locator.desc": "新しいロケータを追加して、パーティクルの位置を制御します",
	"action.uv_turn_mapping": "ターンマッピング",
	"action.uv_turn_mapping.desc": "UV マッピングを 90 度回転させます",
	"action.remove_blank_faces": "ブランクフェイスを削除",
	"action.remove_blank_faces.desc": "選択したブランクフェイスをすべて削除します",
	"web.download_app": "App をダウンロード",
	"uv_editor.turned": "ターンマッピング",
	"display.reference.crossbow": "クロスボウ",
	"dialog.settings.search_results": "検索",
	"settings.animation_snap": "アニメーションスナップ",
	"settings.animation_snap.desc": "アニメーションキーフレームの 1 秒あたりのステップ数。",
	"action.import_optifine_part": "OptiFine Part",
	"action.import_optifine_part.desc": "OptiFine エンティティモデルを読み込みます",
	"data.locator": "ロケーター",
	"mode.start.no_recents": "最近開いたモデルはありません",
	"panel.element": "Element",
	"panel.element.position": "Position",
	"panel.element.size": "Size",
	"panel.element.origin": "Center",
	"panel.element.rotation": "Rotation",
	"message.canvas_limit_error.title": "キャンバス制限エラー",
	"message.canvas_limit_error.message": "キャンバスが４８ユニットに制限されているため、アクションを正しく実行できませんでした。修正するには、ピボットポイントを移動してください。",
	"data.effect": "エフェクト",
	"generic.name": "名前",
	"settings.recent_projects": "最近開いたモデル数",
	"settings.recent_projects.desc": "最近開いたモデルの最大数を変更します",
	"settings.volume": "サウンドエフェクト",
	"settings.volume.desc": "サウンドエフェクトのボリュームを変更します",
	"action.clear_timeline": "タイムラインをクリア",
	"action.clear_timeline.desc": "タイムライン上の使用されていないボーンを削除します",
	"action.select_effect_animator": "アニメーションエフェクト",
	"action.select_effect_animator.desc": "タイムラインを開いてサウンドとエフェクトを追加します",
	"action.timeline_focus": "フィルターチャンネル",
	"action.timeline_focus.desc": "タイムラインに表示するアニメーションチャンネルを選択します",
	"timeline.particle": "パーティクル",
	"timeline.sound": "サウンド",
	"timeline.effects": "エフェクト",
	"data.format": "フォーマット",
	"format.optifine_part": "OptiFine Part",
	"format.optifine_part.desc": "OptiFine エンティティモデルの JPM パーツ",
	"action.reverse_keyframes": "キーフレームを反転",
	"action.reverse_keyframes.desc": "選択したキーフレームを反転します",
	"generic.help": "Help",
	"message.removed_faces": "％0 を削除しました",
	"dialog.sketchfab_uploader.draft": "ドラフト",
	"action.slider_pos": "Position %0",
	"action.slider_pos.desc": "%0 軸上で移動します",
	"action.slider_size": "Size %0",
	"action.slider_size.desc": "%0 軸上でリサイズします",
	"action.slider_rotation": "Rotation %0",
	"action.slider_rotation.desc": "%0 軸上で回転します",
	"action.slider_origin": "Pivot %0",
	"action.slider_origin.desc": "%0 軸上でピポットします",
	"action.rotate_cw": "Rotate %0 +90",
	"action.rotate_cw.desc": "%0 軸上で 90° 回転します",
	"action.rotate_ccw": "Rotate %0 -90",
	"action.rotate_ccw.desc": "%0 軸上で -90° 回転します",
	"action.flip": "Flip %0",
	"action.flip.desc": "%0 軸上で反転します",
	"action.center": "Center %0",
	"action.center.desc": "%0 軸の中央に配置します",
	"action.bring_up_all_animations": "すべてのアニメーターを取り込む",
	"panel.bone": "Bone",
	"data.color": "カラー",
	"generic.export": "書き出し",
	"generic.none": "なし",
	"status_bar.recording": "タイムラプスを記録中…",
	"message.add_to_palette": "パレットを追加",
	"message.size_modifiers": "Shift を押したままにすると、少しずつ変化します。",
	"message.timelapse_start": "スタート",
	"message.timelapse_stop": "ストップ",
	"message.import_palette.replace_palette": "古いパレットを置き換えます",
	"message.import_palette.threshold": "マージ",
	"dialog.timelapse.interval": "インターバル（秒）",
	"dialog.timelapse.source": "ソース",
	"dialog.timelapse.source.interface": "インターフェイス",
	"dialog.timelapse.source.locked": "アングルを固定",
	"dialog.timelapse.destination": "移動先のフォルダ",
	"layout.color.checkerboard": "チェッカーボード",
	"layout.color.checkerboard.desc": "キャンパスの背景と UV エディタ",
	"layout.font.code": "コードフォント",
	"layout.css": "カスタム CSS",
	"settings.category.paint": "ペイント",
	"settings.deactivate_size_limit": "サイズリミット",
	"settings.deactivate_size_limit.desc": "サイズの制限を解除します。：サイズが大きすぎるモデルは不具合を引き起こす可能性があります。",
	"settings.brush_opacity_modifier": "透明度",
	"settings.brush_opacity_modifier.desc": "ブラシの透明度を変更します",
	"settings.brush_size_modifier": "サイズ",
	"settings.brush_size_modifier.desc": "ブラシの大きさを変更します",
	"settings.brush_modifier.pressure": "筆圧",
	"settings.brush_modifier.tilt": "チルト",
	"category.color": "カラー",
	"action.import_theme": "テーマを読み込み",
	"action.export_theme": "テーマを書き出し",
	"action.export_theme.desc": "現在の設定に基づいてテーマファイルを作成します",
	"action.slider_color_h": "色相",
	"action.slider_color_s": "彩度",
	"action.slider_color_v": "明度",
	"action.add_to_palette": "パレットに追加",
	"action.add_to_palette.desc": "パレットに選択したカラーを追加します",
	"action.import_palette": "パレットを読み込み",
	"action.import_palette.desc": "パレットファイルを読み込み",
	"action.export_palette": "パレットを保存",
	"action.export_palette.desc": ".GPL ファイルを書き出します",
	"action.generate_palette": "パレットを生成...",
	"action.generate_palette.desc": "テクスチャからパレットを生成します",
	"action.sort_palette": "ソート",
	"action.sort_palette.desc": "パレット上のすべてのカラーを並べ替えます",
	"action.timelapse": "タイムラプス...",
	"action.timelapse.desc": "モデリングプロセスのタイムラプスを記録します",
	"action.add_keyframe": "キーフレームを追加",
	"action.add_keyframe.desc": "アニメーターにキーフレームを追加します",
	"action.bring_up_all_animations.desc": "変更されたすべてのアニメーターをタイムラインに組み込みます",
	"timeline.timeline": "インストラ",
	"menu.palette.load.default": "デフォルト",
	"panel.color.picker": "picker",
	"panel.color.palette": "Palette",
	"generic.import": "読み込み",
	"settings.brush_modifier.none": "なし",
	"action.export_entity": "Bedrock Entity",
	"action.export_entity.desc": "モデルを Minecraft Bedrock Edition のエンティティモデルとしてエクスポートします",
	"settings.highlight_cubes": "ハイライトエレメント",
	"settings.highlight_cubes.desc": "選択されたエレメントが強調表示されます",
	"action.add_marker": "マーカー",
	"action.add_marker.desc": "タイムラインマーカーを設定します",
	"timeline.pre_effect_script": "スクリプト",
	"format.skin": "Minecraft Skin",
	"format.skin.desc": "プレイヤー/エンティティ スキン編集",
	"message.sketchfab.setup_guide": "Sketchfab でモデルを設定する方法を学びたいですか？ %0",
	"dialog.skin.title": "Minecraft Skin を作成",
	"dialog.skin.model": "モデル",
	"dialog.skin.texture": "テクスチャ (Optional)",
	"action.toggle_skin_layer": "レイヤーの切り替え",
	"action.toggle_skin_layer.desc": "スキンのレイヤーを切り替えます",
	"action.gui_light": "GUI ライト",
	"action.gui_light.desc": "インベントリ内のライティングを選択します",
	"action.gui_light.side": "Side ライト",
	"action.gui_light.front": "Front ライト",
	"action.move_keyframe_back": "キーフレームを戻す",
	"action.move_keyframe_forth": "キーフレームを進める",
	"menu.help": "Help",
	"menu.help.discord": "Discord",
	"menu.help.report_issue": "問題を報告",
	"menu.help.plugin_documentation": "プラグイン API",
	"menu.help.search_action": "探す",
	"menu.help.donate": "寄付",
	"menu.help.about": "About...",
	"menu.preview.background.clipboard": "クリップボードから読み込む",
	"dialog.ignore": "スルー",
	"generic.unset": "Unset",
	"message.invalid_builtin_parent.title": "Error",
	"message.invalid_builtin_parent.message": "モデルの書き出しに際して、無効なモデル '％0' へのリンクが削除されました。",
	"dialog.resize_texture.fill": "Fill",
	"dialog.resize_texture.fill.transparent": "透明度",
	"dialog.resize_texture.fill.color": "カラー",
	"dialog.resize_texture.fill.repeat": "リピート",
	"dialog.scale.element_pivot": "ピボットエレメント",
	"dialog.scale.selection_center": "センターを選択",
	"dialog.create_gif.length_mode": "Length モード",
	"dialog.create_gif.length_mode.seconds": "秒",
	"dialog.create_gif.length_mode.frames": "フレーム",
	"dialog.create_gif.length_mode.animation": "アニメーションの長さ",
	"dialog.create_gif.length_mode.turntable": "ターンテーブル",
	"dialog.save_angle.projection": "プロジェクション",
	"dialog.save_angle.projection.perspective": "視点",
	"dialog.save_angle.projection.orthographic": "直交",
	"dialog.sketchfab_uploader.animations": "アニメーション",
	"dialog.settings.theme": "テーマ",
	"settings.category.interface": "インターフェイス",
	"settings.preview_checkerboard": "プレビュー",
	"settings.preview_checkerboard.desc": "チェッカーボードの背景を切り替えます",
	"settings.uv_checkerboard": "UV エディタ",
	"settings.uv_checkerboard.desc": "UV エディタの背景を切り替えます",
	"category.paint": "Paint",
	"action.fill_mode.color_connected": "コネクトカラー",
	"action.draw_shape_type": "シャープ",
	"action.draw_shape_type.rectangle": "四角形",
	"action.draw_shape_type.rectangle_h": "長方形（空洞）",
	"action.draw_shape_type.ellipse": "円",
	"action.draw_shape_type.ellipse_h": "円（空洞）",
	"action.draw_shape_type.line": "線",
	"action.mirror_painting": "ミラーペイント",
	"action.mirror_painting.description": "モデルの裏側にもペイントします",
	"action.lock_alpha": "アルファチャンネルを固定",
	"action.lock_alpha.description": "ピクセルの透明度をロックします",
	"action.draw_shape_tool": "図形",
	"action.draw_shape_tool.desc": "テクスチャにシンプルな図形を描写します",
	"action.export_gltf": "glTF Model",
	"action.export_gltf.desc": "モデルとアニメーションを glTF ファイルとして書き出します",
	"action.transform_space": "トランスフォームスペース",
	"action.transform_space.desc": "デフォルトのトランスフォームスペース",
	"action.transform_space.global": "グローバル",
	"action.transform_space.local": "ローカル",
	"action.toggle_camera_projection": "カメラの切り替え",
	"action.toggle_camera_projection.desc": "カメラの投影を遠近法と平行投影法の間で切り替えます",
	"action.load_camera_angle": "カメラアングル： %0",
	"action.load_camera_angle.desc": "カメラアングル '%0' を読み込みます",
	"action.slider_face_tint": "色合い指数",
	"action.slider_face_tint.desc": "フェイスの色合いを設定します。 -1 は未設定を意味します。",
	"menu.help.quickstart": "クイックスタート",
	"menu.help.developer": "デベロッパー",
	"menu.help.developer.dev_tools": "開発ツールを開く",
	"menu.help.developer.reset_storage": "初期化",
	"menu.help.developer.reset_storage.confirm": "Blockbench を初期化しますか？すべてのカスタム設定、キーバインド、およびインストールされたプラグインが削除されます。",
	"menu.help.developer.cache_reload": "キャッシュのリロード",
	"menu.preview.orthographic": "正投影",
	"menu.preview.save_angle": "アングルを保存...",
	"menu.preview.angle": "アングル",
	"menu.preview.angle.initial": "初期角度",
	"menu.preview.maximize": "最大化",
	"panel.color.both": "Both",
	"uv_editor.copy_selection": "選択範囲をコピー",
	"uv_editor.paste_selection": "選択範囲を貼り付け",
	"uv_editor.copy_paste_tool.place": "配置",
	"uv_editor.copy_paste_tool.mirror_x": "X 軸で反転",
	"uv_editor.copy_paste_tool.mirror_y": "Y 軸で反転",
	"uv_editor.copy_paste_tool.rotate": "90° 回転",
	"dialog.project.modded_entity_version": "バージョン",
	"dialog.save_angle.position": "カメラポジション",
	"dialog.save_angle.target": "焦点",
	"dialog.skin.pose": "ポーズ",
	"layout.color.frame": "フレーム",
	"layout.color.frame.desc": "ボーダーとタイトルバーのフレーム",
	"settings.large_grid_size": "ブロックグリットサイズ",
	"settings.large_grid_size.desc": "ブロックグリットのサイズを変更します",
	"action.load_plugin_from_url": "URL からプラグインをロード",
	"action.load_plugin_from_url.desc": "サーバーからプラグインをロードします",
	"action.cube_counter.desc": "現在のキューブ数とその他の統計を表示します",
	"action.unlock_everything": "アンロック",
	"action.unlock_everything.desc": "アウトラインのすべてのロックを解除します。",
	"action.load_palette": "パレットをロード",
	"action.load_palette.desc": "パレットプリセットをロードします",
	"action.toggle_locked": "トグルロック",
	"action.toggle_locked.desc": "エレメントをロックするかどうかを切り替えます",
	"action.apply_display_preset": "プリセットを適用",
	"action.apply_display_preset.desc": "カスタム表示設定のプリセットを適用します",
	"action.apply_display_preset.here": "スロットに適用",
	"action.apply_display_preset.everywhere": "すべてのスロットに適用",
	"action.resolve_keyframe_expressions": "キーフレームを解除",
	"action.resolve_keyframe_expressions.desc": "選択したキーフレームを解除します",
	"action.fold_all_animations": "すべてのアニメーターを折りたたむ",
	"menu.palette.load.empty": "ブランク",
	"switches.lock": "ロック",
	"settings.render_sides": "レンダリング",
	"settings.render_sides.desc": "オブジェクトのレンダリング方法を変更します",
	"settings.render_sides.auto": "オート",
	"settings.render_sides.front": "アウトサイド",
	"settings.render_sides.double": "両面",
	"generic.enable": "有効",
	"generic.disable": "無効",
	"generic.redacted": "編集済み",
	"dialog.select_texture.import_all": "すべてを読み込み",
	"dialog.skin.layer_template": "レイヤーテクスチャ",
	"about.version.up_to_date": "最新の状態です",
	"about.version.update_available": "バージョン %0 が利用可能です",
	"settings.category.application": "アプリケーション",
	"settings.streamer_mode": "ストリーマーモード",
	"settings.streamer_mode.desc": "最近開いたモデルなどを非表示にします",
	"settings.automatic_updates": "自動アップデート",
	"settings.automatic_updates.desc": "アップデートをダウンロードして、Blockbench を常に最新の状態に保ちます",
	"action.rotation_space": "ロテートスペース",
	"action.focus_on_selection": "センタービュー",
	"action.focus_on_selection.desc": "選択範囲の中心を向くようにカメラを調整します",
	"action.jump_to_timeline_start": "始端にジャンプ",
	"action.jump_to_timeline_end": "終端にジャンプ",
	"menu.help.updating": "更新中 (%0%)",
	"menu.help.update_failed": "アップデートに失敗しました",
	"menu.animation.loop.once": "１回のみ",
	"menu.animation.loop.hold": "最後のフレームを保持",
	"menu.animation.loop.loop": "ループ",
	"interface.streamer_mode_on": "ストリーマーモードを有効にしました",
	"generic.reset": "リセット",
	"generic.restore": "戻す",
	"keys.mousewheel": "マウスホイール",
	"message.delete_animation.title": "アニメーションを削除",
	"message.delete_animation.message": "Blockbench からアニメーションを削除しました。保存したファイルからもアニメーションを削除しますか？",
	"message.no_animation_to_import": "読み込み可能なアニメーションがありません",
	"dialog.material_instances.title": "マテリアルインスタンス",
	"dialog.animation_import.title": "アニメーションを選択",
	"dialog.create_texture.padding": "パディング",
	"settings.fov": "FOV",
	"settings.fov.desc": "カメラの視野角を変更します。",
	"settings.sync_color": "Sync カラー",
	"settings.sync_color.desc": "異なる Blockbench で色を同期します",
	"settings.minify_bbmodel": "プロジェクトファイルを最小化",
	"settings.minify_bbmodel.desc": ".bbmodelファイルを１行で書き出します",
	"action.edit_material_instances": "マテリアルインスタンスの編集",
	"action.edit_material_instances.desc": "統合版ブロックジオメトリーを編集",
	"action.save_all_animations": "すべてのアニメーションを保存",
	"action.save_all_animations.desc": "現在ロードされているすべてのアニメーションを保存します",
	"action.keyframe_interpolation": "補間",
	"action.keyframe_interpolation.desc": "キーフレーム補間モード",
	"action.keyframe_interpolation.linear": "リニア",
	"action.keyframe_interpolation.catmullrom": "スムーズ",
	"action.timeline_focus.hide_empty": "ブランクチャンネルを非表示にする",
	"menu.file.preferences": "環境設定",
	"menu.animation.blend_weight": "ブレンド",
	"menu.animation.save": "セーブ",
	"menu.animation.properties": "プロパティ...",
	"menu.animation.file": "ファイル",
	"menu.animation.snapping": "スナップ",
	"menu.animation.open_location": "ファイルを参照",
	"panel.keyframe.add_data_point": "データポイントの追加",
	"panel.keyframe.remove_data_point": "データポイントを削除",
	"panel.keyframe.pre": "Pre",
	"panel.keyframe.post": "Post",
	"generic.all": "All",
	"message.small_face_dimensions.title": "互換性のないフェイス",
	"message.small_face_dimensions.message": "選択範囲に 1 より小さいフェイスが含まれています。マッピングシステムは、そのしきい値を下回るフェイスを 0 ピクセルと見なします。これらのフェイスのテクスチャは正しく機能しない可能性があります。",
	"message.small_face_dimensions.face_uv": "現在のフォーマットは、Per-face UV マップをサポートしています。影響を受けるキューブを右クリックし、「UV Mode 」を 「Per-face UV 」に変更してください。",
	"dialog.plugins.outdated_client": "新しいバージョンの Blockbench が必要です",
	"dialog.plugins.outdated_plugin": "このバージョンの Blockbench では動作しません",
	"settings.motion_trails": "モーショントレイル",
	"settings.motion_trails.desc": "アニメーションエディタでモーショントレイルを表示します",
	"settings.antialiasing": "アンチエイリアシング",
	"settings.antialiasing.desc": "プレビューでアンチエイリアスを切り替えます",
	"action.timeline_frame_back": "１フレーム戻る",
	"action.timeline_frame_forth": "１フレーム進む",
	"panel.bone.ik": "逆運動学 (IK)",
	"settings.particle_tick_rate": "パーティクル TPS",
	"settings.particle_tick_rate.desc": "パーティクルエフェクトのティックレートを変更します。",
	"action.lock_motion_trail": "モーショントレイルを固定",
	"action.lock_motion_trail.desc": "現在選択されているグループにモーショントレイルを固定します",
	"menu.animation_file.unload": "ファイルをアンロード",
	"data.null_object": "Null オブジェクト",
	"status_bar.toggle_sidebar": "サイドバーの切り替え",
	"message.load_plugin_failed.title": "プラグインの読み込みに失敗しました :(",
	"message.load_plugin_failed.message": "プラグインのベースファイル名が、Plugin.register() で指定されているプラ​​グインID `％0` と一致していることを確認してください。",
	"dialog.project.uv_mode": "UV モード",
	"dialog.project.uv_mode.box_uv": "ボックス UV",
	"dialog.project.uv_mode.face_uv": "UV",
	"dialog.project.texture_size": "テクスチャ",
	"dialog.animation_export.title": "書き出すアニメーションを選択",
	"dialog.create_texture.rearrange_uv": "アレンジ UV",
	"layout.color.subtle_text": "サブテキスト",
	"layout.color.subtle_text.desc": "サブテキストの色を変更します",
	"settings.interface_scale": "インターフェイススケール",
	"settings.interface_scale.desc": "インターフェイス全体の大きさを調整します",
	"settings.background_rendering": "背景をレンダリング",
	"settings.background_rendering.desc": "ウィンドウがフォーカスされていないときにプレビューを更新します",
	"settings.ctrl_shift_size": "ダブルステップ",
	"settings.ctrl_shift_size.desc": "Control + Shift のグリッド間隔を変更します",
	"settings.hardware_acceleration": "アプリを最適化",
	"settings.hardware_acceleration.desc": "グラフィックカードを使用し、レンダリングを高速化します",
	"action.explode_skin_model": "モデルを分離",
	"action.explode_skin_model.desc": "スキンをバーツごとに分解します",
	"action.export_minecraft_skin": "Minecraft Skin",
	"action.export_minecraft_skin.desc": "Minecraft Skin を PNG テクスチャとして書き出します",
	"action.add_null_object": "Null Object を追加",
	"action.add_null_object.desc": "新しく Null Object を追加する",
	"action.animated_texture_frame": "テクスチャアニメーションのフレーム",
	"action.animated_texture_frame.desc": "アニメーションテクスチャのフレームを設定します",
	"action.export_animation_file": "アニメーションを書き出し...",
	"action.export_animation_file.desc": "選択したアニメーションを新しいファイルに書き出します",
	"action.timeline_graph_editor": "トグルグラフエディタ",
	"action.timeline_graph_editor.desc": "グラフエディタビューとキーフレームビューの間でタイムラインを切り替えます",
	"menu.file.recent.clear": "クリア",
	"switches.shade": "シェード",
	"generic.share": "シェア",
	"dates.minute": "%0 分",
	"dates.minutes": "%0 分",
	"dates.hour": "%0 時",
	"dates.hours": "%0 時",
	"dates.day": "%0 日",
	"dates.days": "%0 日",
	"dates.week": "%0 週",
	"dates.weeks": "%0 週",
	"dates.year": "%0 年",
	"dates.years": "%0 年",
	"message.installed_plugin": "プラグイン %0 がインストールされました",
	"message.installed_plugin_fail": "プラグイン %0 のインストールに失敗しました :(",
	"dialog.share_model.title": "モデルをシェア",
	"dialog.share_model.expire_time": "有効期限",
	"dialog.share_model.failed": "モデルのアップロードに失敗しました :(",
	"action.import_java_block_model": "Java Block/Item Model を追加",
	"action.import_java_block_model.desc": "Minecraft Java block/item model を json ファイルから現在のモデルに追加します",
	"action.share_model": "シェア...",
	"action.share_model.desc": "モデルを共有するためのリンクを生成します",
	"action.import_project": "プロジェクトを読み込み",
	"action.import_project.desc": "別のプロジェクトを .bbmodel ファイルから現在のプロジェクトに読み込みます",
	"dialog.toolbar_edit.hidden_tools": "一部のツールは、現在のモードで使用できないため、非表示になります。",
	"settings.camera_near_plane": "カメラ",
	"settings.camera_near_plane.desc": "オブジェクトがレンダリングされる最小距離。値を大きくすると、テクスチャのちらつきが減少します。デフォルト値は 1 です。",
	"mode.start.keymap_preference.desc": "初めて Blockbench を使う方や、他の 3D プログラムから来た方は、キーマップを選択することをおすすめします。キーマップは設定から変更できます。",
	"message.load_keymap": "キーマップをロードしますか？ 現在のキーバインドが置き換えられます。",
	"message.keymap_loaded": "キーマップのロード",
	"dialog.convert_project.current_format": "現在のフォーマット",
	"dialog.create_texture.rearrange_uv.desc": "新しい UV アレンジメントを作成して、すべてのフェイスに独自のテクスチャを与えます",
	"dialog.create_texture.power.desc": "オートテクスチャサイズを正方形に固定します。",
	"dialog.create_texture.double_use.desc": "２つの要素に同じ UV スペースが割り当てられている場合、新しいマップでも維持します",
	"dialog.create_texture.padding.desc": "テンプレートの間にパディングを追加します",
	"dialog.create_texture.resolution.desc": "テクスチャマップの実際のサイズは、要素の量とサイズによって異なる場合があります",
	"dialog.create_gif.color": "背景の色",
	"dialog.save_angle.zoom": "ズーム",
	"dialog.skin.variant": "バリエーション",
	"dialog.flip_animation.info": "対になるボーンは、名前に 'left' と 'right' というキーワードが入っています。",
	"dialog.flip_animation.offset": "アニメーションの長さの半分だけオフセットします",
	"dialog.export_private_settings.title": "プライベート設定",
	"dialog.export_private_settings.message": "ファイルには次の個人情報が含まれています：**%0**。ファイルを誰かと共有する場合は変更することをおすすめします。",
	"dialog.export_private_settings.keep": "キープ",
	"settings.timecode_frame_number": "フレームナンバー",
	"settings.timecode_frame_number.desc": "タイムコードをフレームナンバーとして表示します",
	"settings.animation_sample_rate": "アニメーションサンプルレート",
	"settings.animation_sample_rate.desc": "１秒あたりのサンプル数をサンプルレートで保存します",
	"keybind.preview_zoom": "ズーム表示",
	"action.gradient_tool": "グラデーション",
	"action.gradient_tool.desc": "テクスチャにカラーグラデーションを作成します",
	"action.import_settings": "設定を読み込み",
	"action.import_settings.desc": ".bbsettings を読み込みます",
	"action.export_settings": "設定を書き出し",
	"action.export_settings.desc": "現在の設定を .bbsettings として書き出します",
	"action.load_keymap": "キーマップをロード",
	"action.load_keymap.default": "デフォルト (Trackpad/Mouse)",
	"action.load_keymap.mouse": "デフォルト (Mouse)",
	"action.load_keymap.default.desc": "ノートパソコンのトラックパッドに最適化されたキーバインド",
	"action.load_keymap.mouse.desc": "Blockbench デフォルトキーバインド",
	"action.load_keymap.blender.desc": "Blender タイプのキーマップ",
	"action.load_keymap.cinema4d.desc": "Cinema 4D タイプのキーマップ",
	"action.load_keymap.maya.desc": "Autodesk Maya タイプのキーマップ",
	"action.import_keymap": "キーマップを読み込み",
	"action.import_keymap.desc": "キーバインドを読み込みます .bbkeymap",
	"action.export_keymap": "キーマップを書き出し",
	"action.export_keymap.desc": "現在のキーマップを .bbkeymap として書き出します",
	"action.edit_history": "履歴...",
	"action.edit_history.desc": "編集履歴を表示し、手順を巻き戻します",
	"action.group_elements": "グループ構成",
	"action.group_elements.desc": "選択した要素を新規グループにまとめる",
	"action.unfold_groups": "グループを展開",
	"action.unfold_groups.desc": "すべてのグループを展開します",
	"action.edit_bedrock_binding": "バインディングを編集...",
	"action.edit_bedrock_binding.desc": "バインドされているボーンを変更します",
	"action.pick_screen_color": "スポイト",
	"action.pick_screen_color.desc": "スクリーンから色をスポイトします",
	"action.view_mode": "表示モード",
	"action.view_mode.desc": "モデルの表示モードを変更します",
	"action.view_mode.textured": "テクスチャ",
	"action.view_mode.solid": "モデル",
	"action.view_mode.wireframe": "ワイヤーフレーム",
	"action.toggle_sidebars": "サイドバー",
	"action.toggle_sidebars.desc": "サイドバーを有効にします",
	"action.set_animation_end": "アニメーションの長さを設定",
	"action.set_animation_end.desc": "選択したアニメーションの終わり時間をタイムラインに設定します",
	"action.flip_animation": "アニメーションを反転する",
	"action.flip_animation.desc": "選択したキーフレームをコピーし、アニメーションを反転します",
	"action.graph_editor_zero_line": "ゼロライン",
	"action.graph_editor_zero_line.desc": "ビューにゼロラインを含めるようにします",
	"menu.texture.render_mode": "レンダーモード",
	"menu.texture.render_mode.emissive": "発光",
	"menu.texture.render_mode.layered": "レイヤード",
	"menu.preview.angle.edit": "視点を変更...",
	"menu.animation.start_delay": "遅延を追加",
	"menu.animation.loop_delay": "遅延",
	"menu.animation.flip_keyframes": "キーフレームを反転",
	"menu.mobile_keyboard.disable_all": "無効",
	"panel.keyframe.toggle_uniform_scale": "ユニスケール",
	"camera_angle.common_isometric_right": "斜投影 右（２：１）",
	"camera_angle.common_isometric_left": "斜投影 左（２：１）",
	"camera_angle.true_isometric_right": "等角投影 右（ 30°）",
	"camera_angle.true_isometric_left": "等角投影 左（ 30°）",
	"menu.help.wiki": "Blockbench Wiki",
	"settings.update_to_prereleases": "プレリリース",
	"settings.update_to_prereleases.desc": "新機能をいち早く体験するために、Blockbench のプレリリースバージョンに自動的に更新されます。ただし、プレリリースバージョンは不安定な場合があるため、実行中のプロジェクトがある場合はこのオプションを有効にしないでください。",
	"data.separator.spacer": "スペーサー",
	"data.separator.linebreak": "改行",
	"data.setting": "Setting",
	"generic.select_all": "すべて選択",
	"generic.select_none": "クリア",
	"projects.new_tab": "New Tab",
	"projects.close_tab": "Close Tab",
	"message.invalid_format.title": "無効なフォーマット",
	"message.invalid_format.message": "このモデルは '%0' の形式で作成されており、現在の Blockbench では使用できません。正しく開くには特定のプラグインが必要になります。",
	"message.invalid_link": "無効なモデル URL",
	"message.default_textures.current": "現在のパス",
	"message.update_after_restart": "アップデートは次回の再起動後にインストールされます",
	"message.copy_paste_tool_viewport": "このツールは 2D エディタでのみ使用できます",
	"dialog.project.shadow_size": "影のサイズ",
	"dialog.find_replace.target": "ターゲット",
	"dialog.find_replace.target.element_names": "名前",
	"dialog.find_replace.target.group_names": "グループネーム",
	"dialog.find_replace.target.animation_names": "アニメーションネーム",
	"dialog.find_replace.target.keyframe_values": "キーフレーム",
	"dialog.find_replace.find": "サーチ",
	"dialog.find_replace.replace": "置き換える",
	"dialog.find_replace.regex": "レギュラー",
	"dialog.add_primitive.shape": "形状",
	"dialog.add_primitive.shape.circle": "サークル",
	"dialog.add_primitive.shape.tube": "チューブ",
	"dialog.add_primitive.shape.cone": "コーン",
	"dialog.add_primitive.shape.cylinder": "シリンダー",
	"dialog.add_primitive.shape.sphere": "スフィア",
	"dialog.add_primitive.shape.torus": "トーラス",
	"dialog.add_primitive.shape.cube": "キューボイド",
	"dialog.add_primitive.shape.pyramid": "ピラミッド",
	"dialog.add_primitive.diameter": "直径",
	"dialog.add_primitive.height": "高さ",
	"dialog.add_primitive.sides": "多角形",
	"dialog.add_primitive.minor_diameter": "幅",
	"dialog.add_primitive.minor_sides": "滑らかさ",
	"dialog.create_texture.combine_polys": "コンバイン",
	"dialog.create_texture.combine_polys.desc": "接続されたフェイスを１つの UV に結合します",
	"dialog.model_stats.meshes": "メッシュ",
	"dialog.export_private_settings.omit": "除外する",
	"layout.select": "レイアウト",
	"layout.options": "オプション",
	"layout.color": "UI カラー",
	"layout.documentation": "ドキュメント",
	"layout.color.bright_ui_text": "ブライト UI",
	"layout.color.bright_ui_text.desc": "ブライドテキスト",
	"layout.name": "名前",
	"layout.author": "オーサー",
	"settings.color_wheel": "カラーホイール",
	"settings.color_wheel.desc": "カラーホイールをカラーピッカーとして使用します",
	"settings.dialog.desc": "\"%0\" ダイアログを表示する",
	"settings.export_empty_groups": "ブランクグループを書き出し",
	"settings.export_empty_groups.desc": "書き出しするファイルに空白のグループを保存します",
	"category.separators": "セパレーター",
	"keybind.preview_area_select": "エリアセレクト",
	"action.color_erase_mode": "消去モード",
	"action.color_erase_mode.desc": "消去モードを有効にすると、塗りつぶしや長方形などのツールは、色を減算します",
	"action.open_from_link": "リンクから開く...",
	"action.open_from_link.desc": "blckbn.ch からモデルを開きます",
	"action.import_obj": "OBJ Model",
	"action.import_obj.desc": "OBJ モデルをメッシュオブジェクトとして読み込みます",
	"action.add_plugin": "プラグインをインストール",
	"action.add_plugin.desc": "プラグインをインストールします",
	"action.remove_plugin": "プラグインをアンインストール",
	"action.remove_plugin.desc": "プラグインをアンインストールします",
	"action.add_mesh": "メッシュを追加",
	"action.add_mesh.desc": "新しいメッシュを追加します",
	"action.add_texture_mesh": "テクスチャメッシュを追加",
	"action.add_texture_mesh.desc": "新しいテクスチャメッシュを追加します",
	"action.find_replace": "検索/置換...",
	"action.find_replace.desc": "名前の一部を見つけて置き換えます",
	"action.hide_everything_except_selection": "非選択範囲を非表示",
	"action.hide_everything_except_selection.desc": "選択した要素を除くすべての要素の表示を切り替えます",
	"action.transform_space.normal": "ノーマル",
	"action.selection_mode": "選択モード",
	"action.selection_mode.desc": "ビューポートで要素を選択する方法を変更する",
	"action.selection_mode.object": "オブジェクト",
	"action.selection_mode.face": "フェイス",
	"action.selection_mode.vertex": "バーテックス",
	"action.create_face": "フェイスまたはエッジを作成する",
	"action.create_face.desc": "選択した頂点にフェイスまたはエッジを作成します",
	"action.convert_to_mesh": "メッシュに変換",
	"action.convert_to_mesh.desc": "選択した要素をメッシュに変換します",
	"action.invert_face": "フェイスを反転",
	"action.invert_face.desc": "選択したフェイスを反転します",
	"action.extrude_mesh_selection": "エクスト",
	"action.extrude_mesh_selection.desc": "メッシュの選択した部分を押し出します",
	"action.loop_cut": "ループカット",
	"action.loop_cut.desc": "選択したライン全体をループ状に分割します",
	"action.merge_meshes": "マージメッシュ",
	"action.merge_meshes.desc": "複数のメッシュを１つにマージします",
	"action.keyframe_uniform": "ユニスケール",
	"action.keyframe_uniform.desc": "選択したキーフレームで均一なスケーリングを有効にします",
	"menu.locator.ignore_inherited_scale": "スケールを無視する",
	"menu.texture_mesh.texture_name": "テクスチャ名...",
	"menu.texture.elements": "エレメントに適用",
	"uv_editor.transparent_face": "透明なフェイス",
	"display.pose_angle": "Pose Angle (Preview)",
	"data.mesh": "メッシュ",
	"dialog.create_texture.type": "タイプ",
	"dialog.create_texture.type.blank": "ブランク",
	"dialog.create_texture.type.template": "テンプレート",
	"dialog.create_texture.type.color_map": "単色テンプレート",
	"dialog.sketchfab_uploader.suggested_tags": "タグ",
	"dialog.sketchfab_uploader.category": "カテゴリー",
	"dialog.sketchfab_uploader.category2": "カテゴリー 2",
	"layout.restore_backup": "カスタマイズしたテーマ \"%0\" が上書きされました。ここをクリックして復元してください。",
	"layout.borders": "ボーダーズ",
	"action.fill_mode.element": "エレメント",
	"action.inset_mesh_selection": "インセット",
	"action.inset_mesh_selection.desc": "メッシュの選択した部分をはめ込みます",
	"action.dissolve_edges": "ディゾルブエッジ",
	"action.dissolve_edges.desc": "選択したエッジをメッシュに適合し、分割したフェイスをマージします",
	"action.split_mesh": "スプリットメッシュ",
	"action.split_mesh.desc": "メッシュの選択したフェイスを新しいメッシュに分割します",
	"action.merge_vertices": "マージバーテクス",
	"action.merge_vertices.desc": "最初に選択した頂点の位置にマージします",
	"action.view_mode.normal": "フェイスの向き",
	"action.snap_uv_to_pixels": "UV ピクセル",
	"action.snap_uv_to_pixels.desc": "選択した UV 頂点をピクセルグリッドにスナップします",
	"menu.file.import.import_open_project": "オープンプロジェクトの読み込み",
	"menu.help.unlock_projects": "すべてのプロジェクトを解除",
	"status_bar.selection.faces": "%0 フェイス",
	"status_bar.selection.vertices": "%0 バーテクス",
	"message.merged_vertices": "%1 で %0 の頂点が見つかりました",
	"settings.vertex_merge_distance": "バーテクス",
	"settings.vertex_merge_distance.desc": "頂点がマージされる距離を変更します",
	"settings.show_only_selected_uv": "セレクト UV",
	"settings.show_only_selected_uv.desc": "選択した UV フェイスのみを UV エディタに表示します",
	"action.merge_vertices.merge_all": "すべてマージ",
	"action.merge_vertices.merge_all_in_center": "中央にすべてマージ",
	"action.merge_vertices.merge_by_distance": "距離マージ",
	"action.merge_vertices.merge_by_distance_in_center": "中央に距離マージ",
	"action.uv_rotate_left": "UV を左回転",
	"action.uv_rotate_left.desc": "選択した UV フェイスを反時計回りに回転します",
	"action.uv_rotate_right": "UV を右回転",
	"action.uv_rotate_right.desc": "選択した UV フェイスを時計回りに回転します",
	"menu.uv.display_uv": "UV を表示",
	"menu.uv.display_uv.selected_faces": "選択したフェイス",
	"menu.uv.display_uv.selected_elements": "すべてのフェイス",
	"menu.uv.display_uv.all_elements": "All Faces on All Elements",
	"menu.paste.face": "UV フェイス",
	"menu.paste.mesh_selection": "メッシュの選択",
	"menu.paste.outliner": "エレメント",
	"uv_editor.show_all_faces": "すべてのフェイスを表示",
	"uv_editor.show_selected_faces": "選択したフェイスを表示",
	"status_bar.selection.edges": "%0 個のエッジ",
	"action.selection_mode.edge": "エッジ",
	"message.cannot_re_import.title": "モデルを再読み込み出来ませんでした :(",
	"message.cannot_re_import.message": "書き出されたモデルフォーマットを Blockbench に再度読み込むことはできません。モデルは必ずプロジェクトファイルとして保存してください。",
	"generic.default": "デフォルト",
	"units.pixels_per_meter": "%0 ピクセル/メートル",
	"mode.pose": "Pose",
	"modifier_actions.resize_both_sides": "両サイドにサイズ変更",
	"modifier_actions.resize_one_side": "一方向にサイズ変更",
	"modifier_actions.draw_line": "ライン",
	"modifier_actions.drag_without_snapping": "スナップせずにドラッグ",
	"modifier_actions.stretch_keyframes": "キーフレームを伸ばす",
	"modifier_actions.resize_background": "背景のサイズを変更する",
	"modifier_actions.select_multiple": "マルチ選択",
	"modifier_actions.select_range": "範囲選択",
	"modifier_actions.drag_to_duplicate": "ドラッグして複製",
	"modifier_actions.uniform_scaling": "ユニスケール",
	"modifier_actions.snap_direction": "スナップ方向",
	"message.no_valid_elements": "有効な要素が選択されていません...",
	"dialog.add_primitive.shape.plane": "プレーン",
	"dialog.save_angle.rotation_mode": "回転モード",
	"dialog.save_angle.rotation": "回転",
	"dialog.save_angle.fov": "FOV",
	"settings.hide_tab_bar": "タブの自動非表示",
	"settings.hide_tab_bar.desc": "タブが１つだけ開いている場合は、タブバーを非表示にします",
	"settings.status_bar_modifier_keys": "修飾キーの提案",
	"settings.status_bar_modifier_keys.desc": "状況に応じた修飾キーをステータスバーに表示します",
	"settings.ground_plane": "グランド",
	"settings.ground_plane.desc": "モデルの下にグランドを表示します",
	"settings.preview_paste_behavior": "デフォルトビューポート",
	"settings.preview_paste_behavior.desc": "編集モードでビューポートにペーストする際の動作を選択し、複数のオプションを利用できるようにします",
	"settings.preview_paste_behavior.always_ask": "常に尋ねる",
	"action.new_window": "新規ウィンドウ",
	"action.new_window.desc": "新しい Blockbench ウィンドウを開きます",
	"action.export_collada": "Collada Model (dae)",
	"action.export_collada.desc": "モデルとアニメーションを dae ファイルとして書き出します",
	"action.paint_mode_uv_overlay": "UV オーバーレイ",
	"action.paint_mode_uv_overlay.desc": "ペイントモードで UV マップをオーバーレイとして表示します",
	"action.bake_animation_into_model": "アニメーションをモデルに焼き付ける",
	"action.bake_animation_into_model.desc": "現在表示されているアニメーションフレームをモデルにベイク処理します。回転と位置のみを適用し、スケールは無視されます。",
	"action.keyframe_interpolation.step": "ステップ",
	"action.set_ik_target": "IK ターゲットを設定する",
	"action.set_ik_target.desc": "逆運動学を介してこのヌルオブジェクトによって移動されるターゲットボーンを選択します",
	"menu.action_control.type.tab": "Tab",
	"menu.action_control.type.angle": "Camera",
	"menu.action_control.recent_in_streamer_mode": "ストリーマー モードが有効になっています",
	"menu.action_control.recent_in_streamer_mode.desc": "最近開いたモデルを表示しますか？",
	"menu.tools": "Tools",
	"menu.file.recent.more": "More...",
	"menu.null_object.lock_ik_target_rotation": "IK ターゲット回転をロックする",
	"menu.animation_file.import_remaining": "残りのアニメーションを読み込み",
	"edit.loop_cut.offset": "オフセット",
	"edit.extrude_mesh_selection.extend": "拡張",
	"cube.color.pink": "ピンク",
	"cube.color.silver": "シルバー",
	"dialog.plugins.offline": "インターネットに接続されていません",
	"dialog.create_texture.pixel_density": "ピクセル",
	"dialog.create_texture.pixel_density.desc": "テクスチャのピクセルサイズ。テクスチャマップは、エレメントの量とサイズによって異なる場合があります。",
	"panel.skin_pose": "Pose",
	"panel.skin_pose.none": "ノーマル",
	"panel.skin_pose.natural": "デフォルト",
	"panel.skin_pose.walking": "歩く",
	"panel.skin_pose.crouching": "しゃがむ",
	"panel.skin_pose.sitting": "座る",
	"panel.skin_pose.jumping": "ジャンプ",
	"panel.skin_pose.aiming": "弓を構える",
	"edit.loop_cut.direction": "向き",
	"data.texture_mesh": "メッシュテクスチャ",
	"generic.left": "Left",
	"generic.right": "Right",
	"mode.start.quick_setup": "クイックセットアップ",
	"mode.start.keymap": "キーマップ",
	"mode.start.quick_setup.more_themes": "More...",
	"dialog.resize_texture.animation_frames": "アニメーションフレーム",
	"dialog.export_emission_map.title": "エミッションマップを書き出し",
	"dialog.export_emission_map.format": "フォーマット",
	"dialog.export_emission_map.format.luminance": "輝度",
	"dialog.export_emission_map.format.luminance_inverted": "輝度を反転",
	"dialog.export_emission_map.format.colors": "カラー",
	"dialog.export_emission_map.threshold": "透明度",
	"dialog.export_emission_map.round_up": "%0 x %1 に切り上げ",
	"dialog.export_emission_map.flip_y": "Y 軸を反転",
	"dialog.select.type": "エレメントタイプ",
	"dialog.create_texture.max_edge_angle": "エッジ角度",
	"dialog.create_texture.max_edge_angle.desc": "２つの面の間の最大角度",
	"dialog.create_texture.max_island_angle": "アイランドアングルのしきい値",
	"dialog.create_texture.max_island_angle.desc": "同じ UV に結合できる最大角度",
	"settings.mobile_panel_side": "モバイルパネル",
	"settings.mobile_panel_side.desc": "Blockbench を横向きで使用するときに、画面パネルのどちら側に表示するかを選択します",
	"settings.obj_face_export_mode": "OBJ 書き出しモード",
	"settings.obj_face_export_mode.desc": "OBJ エクスポーターの変換形式を変更します",
	"settings.obj_face_export_mode.both": "デフォルト",
	"settings.obj_face_export_mode.tris": "トリスに変換",
	"settings.obj_face_export_mode.quads": "クワッドに変換",
	"action.seam_tool": "シームツール",
	"action.seam_tool.desc": "メッシュエッジの UV シームを定義します",
	"action.resolve_group": "グループを解除",
	"action.resolve_group.desc": "エレメントを同じ場所に保持したままグループを解除します",
	"action.move_to_group": "グループに移動",
	"action.move_to_group.desc": "選択した要素を別のグループに移動します",
	"action.select_seam": "シーム UV を選択",
	"action.select_seam.desc": "選択したエッジの UV シームモードを選択します",
	"action.select_seam.auto": "Auto",
	"action.select_seam.join": "Join",
	"action.select_seam.divide": "Divide",
	"action.adjust_brightness_contrast": "明るさとコントラストを調整...",
	"action.adjust_brightness_contrast.desc": "選択したテクスチャの明るさとコントラストを調整します",
	"action.adjust_saturation_hue": "彩度と色相を調整...",
	"action.adjust_saturation_hue.desc": "選択したテクスチャの彩度と色相を調整します",
	"action.invert_colors": "カラーを反転",
	"action.invert_colors.desc": "選択したテクスチャのすべての色を反転します",
	"action.adjust_curves": "トーンカーブを調整...",
	"action.adjust_curves.desc": "選択したテクスチャのトーンカーブを調整します",
	"action.flip_texture_x": "水平方向に反転",
	"action.flip_texture_y": "垂直方向に反転",
	"action.resize_texture": "リサイズ...",
	"action.view_mode.uv": "UV",
	"action.append_to_template": "要素をテンプレートに追加...",
	"action.append_to_template.desc": "現在選択されている要素をテクスチャテンプレートに追加します",
	"action.move_texture_with_uv": "テクスチャを移動",
	"action.move_texture_with_uv.desc": "UV をドラッグするときにテクスチャを移動します",
	"action.timeline_setups": "タイムラインセットアップ",
	"action.save_timeline_setup": "セットアップを保存...",
	"action.save_timeline_setup.desc": "現在選択されているチャンネルのプリセットを保存します",
	"menu.texture": "Texture",
	"menu.texture.render_mode.default": "デフォルト",
	"menu.texture.merge_onto_texture": "上のテクスチャにマージ",
	"menu.animation.unload": "Unload",
	"panel.timeline": "Timeline",
	"action.pan_tool": "パン",
	"action.pan_tool.desc": "テクスチャエディタをナビゲートします",
	"mode.start.recent.favorite": "お気に入りとしてマーク",
	"mode.start.info": "Info",
	"mode.start.target": "Target",
	"mode.start.start": "Start",
	"mode.start.create_new": "新規モデル",
	"mode.start.format.informations": "ポイント：",
	"mode.start.format.resources": "リソース：",
	"format.free.info.meshes": "キューブやカスタムシェイプのメッシュを使って、ローポリモデルを作成することができます。",
	"format.free.info.limitation": "Minecraft などの特殊な形式を必要とするゲームには使用できません。",
	"format.skin.info.skin": "Minecraftのスキンやエンティティのテクスチャを作成できます。",
	"format.skin.info.model": "モデルの編集はできません",
	"format.java_block.info.rotation": "ローテーションは 22.5 度刻みに制限されています",
	"format.java_block.info.size": "モデルのサイズは 3 x 3 x 3 のブロックに制限されています。",
	"format.java_block.info.animation": "このフォーマットではアニメーションに対応していません。mod 用に作成する場合は、GeckoLib を使用してモデルをアニメーション化することができます。",
	"format.bedrock.info.textures": "各モデルには 1 つのテクスチャしか使用できません",
	"format.bedrock_block": "Bedrock Block",
	"format.bedrock_block.desc": "Minecraft Bedrock Edition のブロックモデル",
	"format.modded_entity.info.integer_size": "キューブのサイズは整数に制限されています。",
	"format.modded_entity.info.format": "当フォーマットでは、Javaコードで記述されます。",
	"format.optifine_entity.info.optifine_required": "OptiFineがインストールされていないユーザーは、モデルが表示されません。",
	"format.optifine_entity.info.pivots": "ボーンピボットは固定されています",
	"format_category.low_poly": "Low-Poly",
	"format_category.minecraft": "Minecraft",
	"format_category.other": "Other",
	"format_category.loaders": "Loaders",
	"message.recover_backup.recover": "復元",
	"message.invalid_characters.title": "無効なパス",
	"message.invalid_characters.message": "読み込まれたファイルパスに、無効な文字、大文字、または空白が含まれています。 サポートされている文字は次の通りです： %0",
	"dialog.share_model.thumbnail": "サムネイル",
	"dialog.skin.high_res_texture": "選択した解像度のスキンは、通常の Minecraft スキンとして機能しません",
	"settings.allow_display_slot_mirror": "スロットミラーリング",
	"settings.allow_display_slot_mirror.desc": "Java アイテムスロットをミラーリングできるようにします。WARNING：これは、Minecraft 1.14 以前または特別な場合にのみ機能します。",
	"action.switch_tabs": "タブの切り替え",
	"action.switch_tabs.desc": "開いているタブを切り替えます。",
	"action.unselect_all": "選択を解除",
	"action.unselect_all.desc": "すべての要素、面、頂点、またはキーフレームの選択を解除します",
	"action.save_palette": "パレットを保存...",
	"action.save_palette.desc": "現在のカラーパレットを Blockbench 内に保存します",
	"action.keyframe_column_create": "キーフレーム列を作成",
	"action.keyframe_column_create.desc": "タイムラインのすべてのチャンネルにキーフレームがある場合は、現在のタイムコードでキーを設定します",
	"action.keyframe_column_select": "キーフレーム列を選択",
	"action.keyframe_column_select.desc": "再生ヘッドに沿ってタイムラインのすべてのキーフレームを選択します",
	"menu.uv": "UV",
	"menu.keyframe": "キーフレーム",
	"menu.palette.load.update": "パレットを更新",
	"menu.palette.load.update.desc": "現在の Blockbench パレットの色で更新します",
	"menu.timeline_marker.set_time": "時間をセット...",
	"uv_editor.scale_uv": "スケール UV",
	"action.preview_scene": "シーン",
	"action.preview_scene.desc": "モデルのプレビューシーンを変更します",
	"preview_scene.minecraft_overworld": "オーバーワールド",
	"preview_scene.minecraft_nether": "ネザー",
	"preview_scene.minecraft_end": "エンド",
	"dialog.project.modded_entity_flip_y": "Y 軸を反転",
	"preview_scene.studio": "スタジオ",
	"format.image": "Image",
	"modifier_actions.set_copy_source": "コピー元の設定",
	"message.load_images.title": "画像をロード",
	"message.load_images.edit_image": "画像を編集",
	"dialog.add_primitive.align_edges": "エッジを揃える",
	"dialog.flip_animation.show_in_timeline": "変更したボーンをタイムラインに表示",
	"settings.default_cube_size": "キューブサイズ",
	"settings.default_cube_size.desc": "新しいキューブの大きさを設定します",
	"settings.uniform_keyframe": "ユニキーフレーム",
	"settings.uniform_keyframe.desc": "スケールキーフレームを均一に設定します",
	"settings.nearest_rectangle_select": "エッジステップ：最も近く",
	"settings.nearest_rectangle_select.desc": "キューブの選択範囲を最も近いエッジにスナップします。",
	"settings.pick_color_opacity": "カラーピック透明度",
	"settings.pick_color_opacity.desc": "カラーピッカーで選択した透明度をブラシに設定します",
	"settings.paint_with_stylus_only": "スタイラスペイント",
	"settings.paint_with_stylus_only.desc": "タッチパネルでペイントします。",
	"action.copy_brush_mode": "コピーブラシモード",
	"action.copy_brush_mode.copy": "コピー",
	"action.copy_brush_mode.pattern": "パターン",
	"action.copy_brush_mode.sample": "サンプル",
	"action.brush_shape": "ブラシの形状",
	"action.brush_shape.square": "四角",
	"action.brush_shape.circle": "円",
	"action.blend_mode": "ブレンドモード",
	"action.blend_mode.default": "デフォルト",
	"action.blend_mode.set_opacity": "透明度をセット",
	"action.blend_mode.color": "カラー",
	"action.blend_mode.behind": "ビハインド",
	"action.blend_mode.multiply": "乗数",
	"action.blend_mode.divide": "分割",
	"action.blend_mode.add": "追加",
	"action.blend_mode.subtract": "減算",
	"action.blend_mode.screen": "スクリーン",
	"action.blend_mode.overlay": "オーバーレイ",
	"action.blend_mode.hard_light": "ハードライト",
	"action.blend_mode.difference": "差異",
	"action.copy_brush": "コピーブラシ",
	"action.copy_brush.desc": "テクスチャの一部を複製、描画します。",
	"action.validator_window": "モデルのエラーを表示...",
	"action.validator_window.desc": "現在のモデルのエラーを表示するバリデーターを開きます。",
	"action.cancel_gif": "GIF をキャンセル",
	"menu.text_edit.copy_vector": "ベクターをコピー",
	"menu.brush_presets.dialog": "ブラシのプリセット...",
	"menu.brush_presets.pixel_brush": "ピクセルブラシ",
	"menu.brush_presets.smooth_brush": "スムースブラシ",
	"menu.texture.edit_in_blockbench": "Blockbench で編集",
	"menu.mirror_painting.axis": "軸",
	"menu.mirror_painting.axis.desc": "ペイントストロークをミラーリングする軸を選択します",
	"menu.mirror_painting.global": "グローバル対称性",
	"menu.mirror_painting.global.desc": "グローバル空間でミラーペインティングを有効にします",
	"menu.mirror_painting.local": "ローカル対称性",
	"menu.mirror_painting.local.desc": "ローカル空間でミラーペインティングを有効にします",
	"menu.mirror_painting.texture_frames": "フリップフレームをリピート",
	"menu.mirror_painting.texture_frames.desc": "すべてのフレームにペイントストロークをミラーリングします",
	"format.bedrock_block.info.size_limit": "ブロックの合計サイズは 30 ピクセル以内に制限されています。",
	"format.bedrock_block.info.textures": "Blockbench では、複数のテクスチャをさまざまなキューブに適用できますが、ゲーム内で正しく機能させるには、リソースパックに追加の設定が必要です。",
	"format.image.desc": "2D 画像エディタ",
	"generic.delete_all": "すべて削除",
	"message.child_model_only.open": "親モデルを開く",
	"message.child_model_only.open_with_textures": "親モデルからテクスチャを適用します",
	"dialog.project.credit": "クレジット",
	"dialog.convert_project.create_copy": "コピーを作成",
	"dialog.texture.frame_time": "フレームタイム",
	"dialog.texture.frame_time.desc": "各フレームが表示される時間をティック単位で設定します。 各ティックは 1/20 秒です。",
	"dialog.texture.frame_interpolate": "コネクト",
	"dialog.texture.frame_interpolate.desc": "アニメーションフレームを補間します",
	"dialog.texture.frame_order_type": "ループモード",
	"dialog.texture.frame_order_type.loop": "ループ",
	"dialog.texture.frame_order_type.backwards": "ループリバース",
	"dialog.texture.frame_order_type.back_and_forth": "バックフォース",
	"dialog.texture.frame_order_type.custom": "カスタムオーダー",
	"dialog.texture.frame_order": "フレイムオーダー",
	"dialog.texture.frame_order.desc": "カスタムフレームの順序を設定するために、フレームインデックスを新しい順にリストアップします。",
	"dialog.select.mode": "モード",
	"dialog.select.mode.new": "新規セレクト",
	"dialog.select.mode.add": "セレクトを追加",
	"dialog.select.mode.remove": "セレクトから削除",
	"dialog.select.mode.in_selection": "セレクトからのみ選択",
	"dialog.predicate_overrides.model": "モデル",
	"dialog.predicate_overrides.predicates": "適用条件",
	"dialog.predicate_overrides.variants": "バリアント",
	"dialog.predicate_overrides.start_value": "スタート",
	"dialog.predicate_overrides.add_override": "オーバーライドを追加",
	"dialog.predicate_overrides.add_predicate": "適用条件を追加",
	"dialog.predicate_overrides.generate_overrides": "オーバーライドを生成",
	"dialog.predicate_overrides.confirm_delete": "すべての上書きを削除してもよろしいですか？",
	"dialog.predicate_overrides.predicate.angle": "コンパスの角度",
	"dialog.predicate_overrides.predicate.blocking": "盾を構えているか",
	"dialog.predicate_overrides.predicate.broken": "エリトラなどが壊れているか",
	"dialog.predicate_overrides.predicate.cast": "釣り竿が振られているか",
	"dialog.predicate_overrides.predicate.cooldown": "クールダウン",
	"dialog.predicate_overrides.predicate.damage": "耐久値",
	"dialog.predicate_overrides.predicate.damaged": "耐久値が少しでも消費されているか",
	"dialog.predicate_overrides.predicate.lefthanded": "左利き用か",
	"dialog.predicate_overrides.predicate.pull": "弓やクロスボウの引き具合",
	"dialog.predicate_overrides.predicate.pulling": "弓やクロスボウを引いているか",
	"dialog.predicate_overrides.predicate.charged": "クロスボウが装填されているか",
	"dialog.predicate_overrides.predicate.firework": "ロケット花火が装填されているか",
	"dialog.predicate_overrides.predicate.throwing": "トライデントを構えているか",
	"dialog.predicate_overrides.predicate.time": "時刻",
	"dialog.predicate_overrides.predicate.custom_model_data": "カスタムモデルデータ",
	"dialog.predicate_overrides.predicate.level": "光源レベル",
	"dialog.predicate_overrides.predicate.filled": "バンドルの充填レベル",
	"dialog.predicate_overrides.predicate.tooting": "角笛が鳴らされているか",
	"settings.model_export_scale": "書き出しスケール",
	"settings.model_export_scale.desc": "書き出されたモデルのスケール係数。 デフォルトは 16 で、Blockbench では 1 メートルに変換します。",
	"action.export_fbx": "FBX Model",
	"action.export_fbx.desc": "モデルとアニメーションを fbx ファイルとして書き出します",
	"action.center_lateral": "センターラテラル",
	"action.center_lateral.desc": "選択したエレメントを X 軸と Z 軸の中央に配置します",
	"action.adjust_opacity": "透明度を調整...",
	"action.adjust_opacity.desc": "テクスチャの透明度を調整します",
	"action.rotate_texture_cw": "時計回りに回転",
	"action.rotate_texture_ccw": "反時計回りに回転",
	"action.predicate_overrides": "適用条件のオーバーライドを編集...",
	"action.predicate_overrides.desc": "条件に基づいて、オーバーライドするモデルを選択します",
	"action.auto_set_cullfaces": "カリングフェイスをオートに設定します",
	"action.auto_set_cullfaces.desc": "隣接するブロックによって覆われた場合、自動的にフェイスのレンダリングを無効にします。",
	"menu.texture.edit_externally": "外部ツールで編集",
	"menu.mirror_painting.texture": "対称 2D エディタ",
	"menu.mirror_painting.texture.desc": "画像またはテクスチャでミラーペイントを有効にします",
	"menu.animator.rotation_global": "グローバルスペースで回転",
	"uv_editor.face_properties": "プロパティ",
	"uv_editor.face_properties.material_instance": "マテリアルインスタンス",
	"uv_editor.tint.info": "Tint を有効にすると、Minecraft に色合いを指定できます。バニラでは、色合いは葉っぱやレッドストーンダストなどの特定のブロックにのみ使用できます。",
	"uv_editor.cullface.info": "カリングを有効にすると、Minecraft ワールド内で別のブロックが隣接した場合、ブロックのレンダリングが解除されます。これにより、ゲーム内のパフォーマンスが最適化されます。",
	"uv_editor.material_instance.info": "マテリアルインスタンスはリソースパックの block.json ファイルにて、フェイスに特定のテクスチャとマテリアルを割り当てることができます。",
	"display.reference.frame_invisible": "額縁（透明）",
	"data.settings_profile": "プロフィール",
	"message.display_skin.invalid_name": "Minecraft アカウント名 \"%0\" が見つかりませんでした。",
	"dialog.load_plugins_from_query.title": "プラグインをロード",
	"dialog.load_plugins_from_query.text": "プラグインのインストールが必要なリンクを使用しました。 インストールしますか？",
	"dialog.select_model.title": "モデルを選択",
	"dialog.select_model.bones": "ボーン",
	"dialog.select_model.cubes": "キューブ",
	"dialog.settings.create_profile": "プロファイルを作成...",
	"settings_profile.confirm_delete": "プロファイルの設定を削除してもよろしいですか？",
	"settings_profile.condition.type.selectable": "手動で選択",
	"settings.interface_mode": "UI モード",
	"settings.interface_mode.desc": "インターフェースモード",
	"settings.interface_mode.auto": "オート",
	"settings.interface_mode.desktop": "デスクトップ",
	"settings.interface_mode.mobile": "モバイル",
	"settings.paint_through_transparency": "透明度ペイント",
	"settings.paint_through_transparency.desc": "アルファチャネルのロックが有効な場合、透明なピクセルをペイントします",
	"action.tab_overview": "総覧タブ",
	"action.tab_overview.desc": "すべてのタブをグリッド内に表示し、そのタブにジャンプします",
	"action.slider_color_red": "レッド",
	"action.slider_color_green": "グリーン",
	"action.slider_color_blue": "ブルー",
	"action.add_animation_controller": "アニメーションコントローラを追加",
	"action.add_animation_controller.desc": "新規アニメーションコントローラーを作成します",
	"action.animation_controller_preview_mode": "コントロールプレビュー",
	"action.animation_controller_preview_mode.paused": "ポーズ",
	"action.animation_controller_preview_mode.manual": "マニュアルプレビュー",
	"action.animation_controller_preview_mode.play": "オート",
	"action.keyframe_interpolation.bezier": "ベジェ",
	"action.keyframe_bezier_linked": "リンクベジェハンドル",
	"action.keyframe_bezier_linked.desc": "左右のキーフレームのベジェハンドルを接続します",
	"action.reset_keyframe_handles": "キーフレームハンドルをリセット",
	"action.reset_keyframe_handles.desc": "選択したベジェハンドルをリセットします",
	"action.looped_animation_playback": "ループ再生",
	"action.looped_animation_playback.desc": "アニメーションプレビューをループ再生します",
	"timeline.bind_to_actor": "アクターにバインド",
	"animation_controllers.select_preset": "コントローラーのプリセットを選択...",
	"animation_controllers.state.animations": "アニメーション",
	"animation_controllers.state.particles": "パーティクル",
	"animation_controllers.state.sounds": "サウンド",
	"animation_controllers.state.on_entry": "エントリー",
	"animation_controllers.state.on_exit": "イグジット",
	"animation_controllers.state.transitions": "トランジション",
	"animation_controllers.state.condition": "コンディション",
	"animation_controllers.state.blend_transition": "ブレンドタイム",
	"animation_controllers.state.shortest_path": "最短パスでブレンドします",
	"animation_controllers.state.edit_transition": "トランジションを退出",
	"menu.color_picker.picker_type": "ピッカータイプ",
	"menu.color_picker.picker_type.square": "四角形",
	"menu.color_picker.picker_type.wheel": "ホイール",
	"menu.color_picker.slider_mode": "スライダーモード",
	"menu.color_picker.slider_mode.hsv": "色相、彩度、明度",
	"menu.color_picker.slider_mode.rgb": "RGB",
	"menu.texture.render_mode.additive": "アクティブ",
	"panel.color.picker_options": "Color Picker Options",
	"panel.animation_controllers": "Animation Controller",
	"display.preset.armor_stand": "地面（アーマースタンド）",
	"data.file_path": "ファイルパス",
	"dialog.extrude.orientation": "オリエンテーション",
	"dialog.extrude.orientation.upright": "正立",
	"dialog.extrude.orientation.flat": "フラット",
	"dialog.scale.box_uv_warning": "ボックス UV モデルをスケーリングすると、モデルの UV が壊れる可能性があります。 代わりに、モデルを外部的にスケールするか、ファイル > プロジェクトでフェイスごとに UV モードを切り替えてみてください。",
	"dialog.create_gif.format": "フォーマット",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "PNG オーダー",
	"dialog.create_gif.pixelate": "ピクセル化",
	"dialog.create_gif.bg_image": "背景画像",
	"dialog.create_gif.turn.desc": "レコード中にモデルを回転します。 モデルを時計回りに回転するには、負の値を使用します。 値 60 は、1 秒ごとに 1 回転に相当します。",
	"settings_profile.condition": "コンディション",
	"settings_profile.condition.type.file_path.desc": "正規表現構文を使用して、現在のプロジェクトのファイルパスと一致させます。 ディレクトリには / を使用します",
	"settings.only_selected_bezier_handles": "選択したベジェハンドルのみを表示",
	"settings.only_selected_bezier_handles.desc": "選択されていないベジェハンドルを非表示にします",
	"settings.embed_textures": "テクスチャの埋め込み",
	"settings.embed_textures.desc": "テクスチャファイルを .bbmodel ファイルに埋め込みます",
	"action.selection_mode.cluster": "クラスター",
	"dialog.copied_to_clipboard": "クリップボードにコピーしました",
	"data.reference_image": "参考画像",
	"message.delete_reference_image": "この参考画像を削除してもよろしいですか？この工程は元に戻すことはできません。",
	"message.add_reference_image.message": "参考画像をロードする場所を選択します",
	"message.add_reference_image.project": "プロジェクトに追加",
	"message.add_reference_image.app": "すべてのプロジェクトに追加",
	"message.import_particle_texture.import": "パーティクルテクスチャをインポート",
	"message.import_particle_texture.message": "パーティクルに使用するテクスチャファイルをインポートしますか？",
	"message.save_codec_selector.title": "モデルフォーマットを保存",
	"message.save_codec_selector.message": "保存したいモデル形式を選択します。",
	"message.save_codec_selector.project_file": "Blockbench プロジェクト (.bbmodel)",
	"message.save_codec_selector.both": "両方",
	"message.display_skin.username": "ユーザーネーム (Java)",
	"message.palette_locked": "パレットは固定されています",
	"dialog.project.default_uv_mode": "UV モード",
	"dialog.project.default_uv_mode.description": "デフォルトの UV モード。 UV モードはキューブごとに変更することができます。",
	"dialog.export_options.title": "設定をエクスポート",
	"dialog.edit_texture.preview": "プレビュー",
	"dialog.proportional_editing.range": "範囲",
	"dialog.proportional_editing.falloff": "フォールオフ",
	"dialog.proportional_editing.falloff.linear": "リニア",
	"dialog.proportional_editing.falloff.hermite_spline": "スムーズ",
	"dialog.proportional_editing.falloff.constant": "コンスタント",
	"dialog.proportional_editing.selection": "選択",
	"dialog.proportional_editing.selection.linear": "リニアディスタンス",
	"dialog.proportional_editing.selection.connections": "接続",
	"dialog.mirror_painting_texture_center.middle": "ミドル",
	"dialog.mirror_painting_texture_center.custom": "カスタム",
	"dialog.settings.reset_to_default": "初期値にリセット",
	"keybindings.item.num_slider.increase": "増加",
	"keybindings.item.num_slider.decrease": "減少",
	"settings.always_show_splash_art": "スプラッシュアートを表示",
	"settings.always_show_splash_art.desc": "スタート画面にスプラッシュアートを常に表示します",
	"action.slider_palette_color": "パレットカラーをスイッチ",
	"action.slider_palette_color.desc": "パレット内のカラーを循環します",
	"action.proportional_editing": "プロポーショナル編集",
	"action.proportional_editing.desc": "メッシュの一部を編集するときに周囲の頂点に比例して影響を与えます",
	"action.limit_to_palette": "限定パレット",
	"action.limit_to_palette.desc": "テクスチャのカラーを現在のパレット内に制限します",
	"action.edit_reference_images": "参考画像の編集",
	"action.edit_reference_images.desc": "参考画像モードをオンにして、画像と設計図を追加または編集します",
	"action.add_reference_image": "参考画像を追加",
	"action.reference_image_from_clipboard": "クリップボードから",
	"action.reference_image_list": "参考画像",
	"action.connect_uv_faces": "UV フェイスを接続する",
	"action.connect_uv_faces.desc": "選択した UV フェイスを最後に選択した UV フェイスに接続します",
	"action.merge_uv_vertices": "頂点 UV を結合",
	"action.merge_uv_vertices.desc": "最初に選択した UV 頂点を最後に選択した UV 頂点にスナップします",
	"action.bedrock_animation_mode": "Bedrock アニメーションモード",
	"action.bedrock_animation_mode.desc": "Minecraft: Bedrock Edition のアニメーションの編集モードを選択します",
	"action.bedrock_animation_mode.entity": "エンティティ",
	"action.bedrock_animation_mode.attachable_first": "アイテム　一人称視点",
	"action.bedrock_animation_mode.attachable_third": "アイテム　三人称視点",
	"timeline.amplify": "増幅",
	"menu.options": "オプション...",
	"menu.palette.lock_palette": "パレットをロック",
	"menu.uv.export": "UV マッピングのエクスポート",
	"menu.uv.flip_x": "Mirror X",
	"menu.uv.flip_y": "Mirror Y",
	"menu.mirror_painting.enabled": "有効",
	"reference_image.position": "Position",
	"reference_image.size": "Size",
	"reference_image.rotation": "Rotation",
	"reference_image.opacity": "透明度",
	"reference_image.visibility": "可視化",
	"reference_image.clear_mode": "クリアーモード",
	"reference_image.layer": "レイヤー",
	"reference_image.layer.background": "モデル後方",
	"reference_image.layer.viewport": "モデル上方",
	"reference_image.layer.float": "インターフェース上",
	"reference_image.layer.blueprint": "設計図をロック",
	"reference_image.scope": "スコープ",
	"reference_image.scope.project": "このプロジェクトのみ",
	"reference_image.scope.global": "すべてのプロジェクト",
	"reference_image.enabled_modes": "モードで有効",
	"codec.common.encoding": "エンコード",
	"codec.common.armature": "グループをアマチュアとしてエクスポート",
	"codec.common.export_animations": "アニメーションをエクスポート",
	"codec.common.embed_textures": "テクスチャの埋め込み",
	"preview.center_camera": "センターカメラ",
	"display.reference.frame_top": "額縁トップ",
	"display.reference.frame_top_invisible": "額縁トップ（透明）",
	"action.proportional_editing_range": "プロポーショナル編集範囲",
	"action.proportional_editing_range.desc": "プロポーショナル編集の範囲を調整します",
	"action.toggle_all_reference_images": "すべての参考画像を表示/非表示",
	"action.toggle_all_reference_images.desc": "すべての参考画像の表示を切り替えます",
	"action.add_animation_controller_state": "ステートを追加",
	"action.add_animation_controller_state.desc": "アニメーションコントローラーに新しいステートを追加します",
	"menu.slider.round_value": "四捨五入値",
	"texture.error.too_large": "解像度が最大値の %0 を超えています",
	"dialog.copy_to_clipboard": "クリップボードにコピー",
	"dialog.open_url": "URL を開く",
	"reference_image.image": "イメージ",
	"uv_editor.rotate_uv": "Rotate UV",
	"generic.error": "Error",
	"projects.start_screen": "スタート画面",
	"message.invalid_link.message": "ロードしようとしている共有モデル \"%0\" は無効または有効期限が切れています。",
	"message.plugin_dependencies.title": "プラグインの依存関係",
	"message.plugin_dependencies.message1": "プラグインには次の依存関係が必要です：",
	"message.plugin_dependencies.message1_update": "プラグイン %0 が更新され、次の依存関係が必要になりました：",
	"message.plugin_dependencies.message2": "インストールを継続しますか？",
	"message.plugin_dependencies.invalid": "プラグインは無効な依存関係があるためインストールできませんでした :",
	"message.preview_scene_load_failed": "プレビューの読み込みに失敗しました。インターネット接続をご確認ください。",
	"dialog.convert_project.text1": "プロジェクトを別のフォーマットに変換します。",
	"dialog.convert_project.text2": "フォーマットにはさまざまな機能と制限があるため、変換するとプロジェクトの一部が壊れる可能性があります。",
	"dialog.convert_project.text3": "変換を元に戻すことはできないため、デフォルトでコピーが作成されます。",
	"dialog.unsaved_work.title": "Unsaved Work",
	"dialog.unsaved_work.text": "次のプロジェクトには、保存されていない変更が含まれています。 変更を保存しますか？",
	"dialog.unsaved_work.discard_all": "破棄",
	"dialog.unsaved_work.save_all": "すべて保存",
	"dialog.resize_texture.mode": "モード",
	"dialog.resize_texture.mode.crop": "トリミング/拡大",
	"dialog.resize_texture.mode.scale": "スケール",
	"dialog.plugins.is_installed": "インストール済み",
	"dialog.plugins.is_disabled": "無効",
	"dialog.plugins.disable": "無効",
	"dialog.plugins.enable": "有効",
	"dialog.plugins.dependencies": "以下に依存します：",
	"dialog.view_backups.open_folder": "フォルダーを開く",
	"dialog.share_model.reference_images": "参考画像を含める",
	"dialog.share_model.too_large": "アップロードに失敗しました：モデルが大きすぎます :(",
	"dialog.share_model.too_large_references": "アップロードに失敗しました：モデルが大きすぎます。 参考画像なしで試してみてください。",
	"settings.stretch_linked": "リンクストレッチ",
	"settings.stretch_linked.desc": "同じ値で立方体を全方向に引き伸ばします",
	"settings.grids": "グリッドを表示",
	"settings.grids.desc": "３D グリットを表示します",
	"settings.double_click_switch_tools": "ダブルクリック切り替え",
	"settings.double_click_switch_tools.desc": "ダブルクリックでツールを切り替えます",
	"settings.outlines_in_paint_mode": "選択範囲のアウトライン",
	"settings.outlines_in_paint_mode.desc": "ペイントモードでアウトラインを表示します",
	"settings.json_indentation": "Json インデント",
	"settings.json_indentation.desc": "Json ファイルのインデントスタイルを変更します",
	"settings.json_indentation.tabs": "Tabs",
	"settings.json_indentation.spaces_4": "Spaces: 4",
	"settings.json_indentation.spaces_2": "Spaces: 2",
	"action.slider_stretch": "ストレッチ",
	"action.slider_stretch.desc": "UV を変更せずに、%0 軸上で立方体を引き伸ばします",
	"action.view_backups": "バックアップ",
	"action.view_backups.desc": "プロジェクトのバックアップリストを参照します",
	"action.search_outliner": "アウトラインを検索",
	"action.search_outliner.desc": "アウトライン内のエレメントを検索します",
	"action.mirror_modeling": "ミラーモデリング",
	"action.mirror_modeling.desc": "X 軸でのミラーモデリングを有効にすると、ビューポートで行った変更が反対側にも反映されます。",
	"action.allow_element_mirror_modeling": "ミラーモデリングを許可",
	"action.allow_element_mirror_modeling.desc": "選択したエレメントがミラーモデリングの影響を受けるかどうかを選択します",
	"action.switch_face_crease": "フェイスクリース",
	"action.switch_face_crease.desc": "クワッドを中央で折りたたむ方向を変えます",
	"action.clear_unused_texture_space": "ブランクスペースをクリア",
	"action.clear_unused_texture_space.desc": "UV マッピングされていないテクスチャをクリアします",
	"action.split_screen": "スクリーンを分割",
	"action.split_screen.desc": "ビューポートの分割モードを選択します",
	"action.split_screen.single": "シングル",
	"action.split_screen.double_horizontal": "ホリゾンタル",
	"action.split_screen.double_vertical": "バーティカル",
	"action.split_screen.quad": "クワッド",
	"action.split_screen.triple_left": "トリプルレフト",
	"action.split_screen.triple_right": "トリプルライト",
	"action.split_screen.triple_top": "トリプルトップ",
	"action.split_screen.triple_bottom": "トリプルボトム",
	"action.uv_project_from_view": "UV プロジェクト",
	"action.uv_project_from_view.desc": "3D ビューから選択した UV を自動的に生成します",
	"action.graph_editor_other_graphs": "他のグラフを表示",
	"action.graph_editor_other_graphs.desc": "選択されていない軸のグラフを表示します",
	"action.graph_editor_include_other_graphs": "他のグラフを含める",
	"action.graph_editor_include_other_graphs.desc": "ビューで選択されていないグラフが含まれるか",
	"action.set_ik_source": "IK ルートをセット",
	"action.set_ik_source.desc": "オブジェクトが移動する際に使用するルートボーンを選択します",
	"edit.loop_cut.cuts": "カット",
	"panel.element.stretch": "Stretch",
	"preview_scene.minecraft_plains": "平原",
	"preview_scene.minecraft_cherry_grove": "桜の丘",
	"preview_scene.minecraft_snowy_tundra": "ツンドラ",
	"preview_scene.minecraft_sunset": "夕暮れ",
	"preview_scene.minecraft_night": "真夜中",
	"preview_scene.minecraft_desert": "砂漠",
	"preview_scene.minecraft_underwater": "水中",
	"preview_scene.minecraft_coral_reef": "サンゴ礁",
	"preview_scene.minecraft_lush_cave": "繁茂した洞窟",
	"preview_scene.minecraft_deep_dark": "ディープダーク",
	"generic.navigate_forward": "前方",
	"generic.navigate_back": "後方",
	"action.element_render_order": "レンダリングオーダー",
	"action.element_render_order.default": "オート",
	"action.element_render_order.behind": "ビハインド",
	"action.element_render_order.in_front": "フロント",
	"message.installing_update.title": "利用可能なアップデートがあります",
	"message.installing_update.message": "新しいバージョンをインストールする準備ができました。 アップデートが完了するまでコンピューターの電源を切らずに、%0 秒お待ちください。",
	"settings.brush_cursor_2d": "2D ブラシカーソル",
	"settings.brush_cursor_2d.desc": "2D ワークスペースでブラシにアウトラインを表示します",
	"settings.brush_cursor_3d": "3D ブラシカーソル",
	"settings.brush_cursor_3d.desc": "3D ワークスペースでブラシにアウトラインを表示します",
	"settings.cdn_mirror": "CDN ミラーモード",
	"settings.cdn_mirror.desc": "CDN ミラーを使用してプラグインを常に最新の状態にします",
	"data.layer": "レイヤー",
	"data.panel": "パネル",
	"generic.confirm_delete": "これらを削除してもよろしいですか？",
	"format_category.general": "General",
	"modifier_actions.no_uniform_scaling": "フリースケーリング",
	"message.texture_refresh_conflict.title": "テクスチャのバージョンが競合しています",
	"message.texture_refresh_conflict.message": "テクスチャファイルには、Blockbench のバージョンと競合する変更が含まれている可能性があります",
	"message.texture_refresh_conflict.keep_ours": "Blockbench バージョンを維持する",
	"message.texture_refresh_conflict.keep_theirs": "ファイルをロードし、Blockbench のすべての変更とレイヤーを破棄します",
	"message.group_required_to_animate": "このタイプのエレメントをアニメーション化することはできません。 グループを作成してアニメーション化します。",
	"dialog.texture.uv_size": "UV サイズ",
	"dialog.advanced_screenshot.angle_preset": "アングルプリセット",
	"dialog.advanced_screenshot.resolution": "解像度",
	"dialog.advanced_screenshot.zoom_to_fit": "フィットズーム",
	"dialog.advanced_screenshot.zoom": "ズーム / Focal Length",
	"dialog.advanced_screenshot.anti_aliasing": "アンチエイリアス",
	"dialog.advanced_screenshot.anti_aliasing.off": "オフ",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "マルチサンプリング",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "スーパーサンプリング",
	"dialog.advanced_screenshot.show_gizmos": "ギズモを表示",
	"dialog.advanced_screenshot.shading": "シェーディング",
	"settings.auto_keyframe": "オートキーフレーム",
	"settings.auto_keyframe.desc": "タイムラインの開始時にデフォルト値を使用してキーフレームを自動的に作成します",
	"settings.modded_entity_integer_size": "エンティティ整数サイズ",
	"settings.modded_entity_integer_size.desc": "Modded Entity 形式のキューブのサイズを整数に制限します。小数点は一部のバージョンで技術的にサポートされていますが、整数の方が UV マッピングをはるかに簡単にします。",
	"category.layers": "Layers",
	"keybind.paint_secondary_color": "2次色ペイント",
	"action.selection_tool_operation_mode": "動作モードの選択",
	"action.selection_tool_operation_mode.create": "新規選択",
	"action.selection_tool_operation_mode.add": "選択に追加",
	"action.selection_tool_operation_mode.subtract": "選択範囲から外す",
	"action.selection_tool_operation_mode.intersect": "Intersect",
	"action.pixel_perfect_drawing": "パーフェクトピクセル描画",
	"action.pixel_perfect_drawing.desc": "曲線部分において、二重ピクセルを発生させずに、滑らかなピクセルラインを描画します",
	"action.selection_tool": "選択ツール",
	"action.selection_tool.desc": "画像の一部を選択します",
	"action.selection_tool.rectangle": "長方形",
	"action.selection_tool.ellipse": "楕円形",
	"action.selection_tool.lasso": "なげわ",
	"action.selection_tool.wand": "魔法の杖",
	"action.selection_tool.color": "同色",
	"action.move_layer_tool": "レイヤーの移動",
	"action.move_layer_tool.desc": "現在のレイヤーまたは選択範囲を移動します",
	"action.export_modded_animations": "エンティティアニメーションのエクスポート",
	"action.export_modded_animations.desc": "Minecraft Java Edition の MOD エンティティモデルのアニメーションをエクスポートします",
	"action.swap_colors": "スワップカラー",
	"action.swap_colors.desc": "メインカラーとセカンダリカラーを交換します",
	"action.apply_mesh_rotation": "ローテーションを許可",
	"action.apply_mesh_rotation.desc": "メッシュの回転をリセットし、代わりにジオメトリに適用します",
	"action.flip_texture_x.desc": "テクスチャまたはレイヤーを水平方向に反転します",
	"action.flip_texture_y.desc": "テクスチャまたはレイヤーを垂直方向に反転します",
	"action.rotate_texture_cw.desc": "テクスチャまたはレイヤーを時計回りに回転します",
	"action.rotate_texture_ccw.desc": "テクスチャまたはレイヤーを反時計回りに回転します",
	"action.crop_texture_to_selection": "テクスチャをクロップ",
	"action.create_empty_layer": "新規レイヤー",
	"action.enable_texture_layers": "レイヤーを許可",
	"action.disable_texture_layers": "レイヤーを無効",
	"action.layer_opacity": "レイヤー透明度",
	"action.layer_to_texture_size": "レイヤーを拡張",
	"action.layer_to_texture_size.desc": "テクスチャのサイズまでレイヤーを拡大します",
	"action.merge_layer_down": "レイヤーを統合",
	"action.merge_layer_down.desc": "下のレイヤーと統合します",
	"action.advanced_screenshot": "高度なスクリーンショット...",
	"action.advanced_screenshot.desc": "高度なオプションを使用してモデルのスクリーンショットを撮影します",
	"action.bake_ik_animation": "IK ベイク処理",
	"action.bake_ik_animation.desc": "インバースキネマティクスを適用したアニメーションにベイク処理を施します",
	"action.save_animation_preset": "アニメーションプリセットを保存...",
	"action.save_animation_preset.desc": "選択したキーフレームをアニメーションプリセットとして保存します",
	"action.animation_onion_skin": "アニメートレイヤースキン",
	"action.animation_onion_skin.desc": "アニメーション中ののワイヤーフレームビューを参照用に表示します",
	"action.apply_animation_preset": "アニメーションプリセットを適用",
	"action.apply_animation_preset.desc": "アニメーションのプリセットリストから選択して、ボーンに適用します",
	"menu.brush_presets.pixel_perfect": "パーフェクトピクセルブラシ",
	"panel.layers": "Layers",
	"uv_editor.copy_paste_tool.to_layer": "新規レイヤーへ",
	"format.image.new": "新規イメージ",
	"format.image.info.summary": "2D 画像エディタを使用すれば、外部ツールを必要とせずに、Blockbench でテクスチャやピクセルアートを作成・編集できます。",
	"settings.move_with_selection_tool": "選択ツールを使って選択した範囲を移動します",
	"settings.move_with_selection_tool.desc": "レイヤー移動ツールに切り替えることなく、選択範囲を直接移動できるようにします",
	"settings.final_newline": "改行を追加",
	"settings.final_newline.desc": "ファイルの末尾に改行を挿入します",
	"action.crop_layer_to_selection": "レイヤーを選択範囲にトリミング",
	"action.edit_mode_uv_overlay.desc": "編集モードで UV マップをオーバーレイとして表示します",
	"menu.image": "Image",
	"menu.texture.discard_changes": "元に戻す",
	"menu.texture.discard_changes.desc": "ファイルから最新バージョンをダウンロードします",
	"panel.textures.images": "Images",
	"dialog.advanced": "アドバンスド",
	"dialog.recommended_option": "推奨",
	"modifier_actions.snap_to_center": "センターへスナップ",
	"modifier_actions.snap_to_pixels": "ピクセルへスナップ",
	"message.invalid_format.install_plugin": "プラグイン '%0' をインストール",
	"message.plugin_deprecated.message": "このプラグインは推奨されていません、インストールしてもよろしいですか？",
	"message.plugin_deprecated.install_anyway": "無視してインストール",
	"message.image_editor.not_found": "選択した画像エディタが見つかりませんでした。別のオプションを選択してください。",
	"message.knife_tool.confirm": "ナイフツールを使うには、%0 を押すか、こちらをクリックしてください",
	"message.knife_tool.skipped_face": "異なるフェイス同士をカットすることはできません。カットする場合は、エッジや頂点を選択してください",
	"message.optimize_animation.keyframes_removed": "%0 個の余分なキーフレームを削除しました",
	"message.optimize_animation.nothing_to_optimize": "すでに最適化されています",
	"message.duplicate_bone_copy_animation.title": "アニメーションをコピー",
	"message.duplicate_bone_copy_animation.message": "複製したボーンは %0 でアニメーション化されています。キーフレームを新しいボーンにコピーしますか？",
	"message.auto_fix_mesh_edit.title": "オートフィックス",
	"message.auto_fix_mesh_edit.revert": "編集を取り消す",
	"message.auto_fix_mesh_edit.overlapping_vertices": "いくつかの頂点が同じ場所に移動されました。",
	"message.auto_fix_mesh_edit.concave_quads": "フェイスが凹状になり、UV マッピングとレンダリングで問題が発生する可能性があります。Blockbench はこれを自動的に修正します:",
	"message.auto_fix_mesh_edit.merge_vertices": "頂点をマージ",
	"message.auto_fix_mesh_edit.split_quads": "スプリットクワッド",
	"message.load_images.add_image": "画像を追加",
	"dialog.project.modded_entity_entity_class": "エンティティクラス",
	"dialog.resize_texture.offset": "オフセット",
	"dialog.animated_texture_editor.code_reference": "コードリファレンス",
	"dialog.animated_texture_editor.code_reference.about": "このコードはテクスチャアニメーションを実装するための参考用に作成されたものであり、そのままでは動作しない場合があります。詳細については、ドキュメントを参照してください。",
	"dialog.animated_texture_editor.code_reference.docs": "ドキュメント",
	"dialog.animated_texture_editor.reframe": "リフレーム",
	"dialog.animated_texture_editor.stride": "フレームサイズ",
	"dialog.animated_texture_editor.frames": "フレーム数",
	"dialog.animated_texture_editor.add_frame": "フレームを追加",
	"dialog.animated_texture_editor.resize_frames": "フレームをリサイズ...",
	"dialog.animated_texture_editor.apply": "適応",
	"dialog.add_primitive.edge_size": "エッジサイズ",
	"dialog.change_animation_speed.speed": "スピード",
	"dialog.change_animation_speed.adjust_snapping": "スナップを調整",
	"dialog.optimize_animation.selection": "選択",
	"dialog.optimize_animation.selection.selected_keyframes": "キーフレーム",
	"dialog.optimize_animation.selection.selected_animation": "アニメーション",
	"dialog.optimize_animation.selection.all_animations": "すべてのアニメーション",
	"dialog.optimize_animation.thresholds": "値",
	"dialog.import_obj.obj": "OBJ ファイル",
	"dialog.import_obj.mtl": "MTL ファイル",
	"dialog.import_obj.scale": "スケール",
	"layout.thumbnail": "カスタムサムネイル CSS",
	"settings.pixel_grid": "ピクセルグリット",
	"settings.pixel_grid.desc": "エディットモードで、テクスチャにピクセルグリッドを表示します",
	"settings.image_editor_grid_size": "画像エディタのグリットサイズ",
	"settings.image_editor_grid_size.desc": "画像エディタの最大グリットサイズを変更します",
	"settings.ground_plane_double_side": "Ground Plane Double-sided",
	"settings.ground_plane_double_side.desc": "Make the ground plane visible from below",
	"settings.optifine_save_default_texture": "OptiFine JEM : テクスチャをエクスポート",
	"settings.optifine_save_default_texture.desc": "選択したテクスチャをモデルのデフォルトテクスチャとしてエクスポートします",
	"action.slider_color_select_threshold": "カラー選択しきい値",
	"action.slider_color_select_threshold.desc": "How close the color of a neighboring pixel has to be to get selected by color or wand select",
	"action.stretch_tool": "ストレッチ",
	"action.stretch_tool.desc": "要素を引き伸ばします",
	"action.knife_tool": "ナイフ",
	"action.knife_tool.desc": "メッシュを小さくカットします",
	"action.duplicate_project": "プロジェクトを複製",
	"action.duplicate_project.desc": "進行中のプロジェクトのコピーを作成します",
	"action.transform_space.parent": "Parent",
	"action.transform_pivot_space": "Pivot Transform Space",
	"action.solidify_mesh_selection": "ソリット化",
	"action.solidify_mesh_selection.desc": "選択したフェイスをソリッド化します",
	"action.animated_texture_editor": "フリップブックアニメーション...",
	"action.animated_texture_editor.desc": "テクスチャのフリップブックアニメーションを設定、または編集します",
	"action.center_individual_pivots": "センターピボット",
	"action.center_individual_pivots.desc": "選択したピボットポイントを中心に設定します",
	"action.uv_cycle": "サイクル UV",
	"action.uv_cycle.desc": "UV 頂点の順序を循環します",
	"action.uv_cycle_invert": "逆サイクル UV",
	"action.uv_cycle_invert.desc": "UV 頂点の順序を逆にします",
	"action.slider_animation_controller_speed": "Controller Playback Speed",
	"action.slider_animation_controller_speed.desc": "アニメーションコントローラの再生速度",
	"action.optimize_animation": "アニメーションを最適化",
	"action.optimize_animation.desc": "キーフレームの数を減らして、アニメーションを最適化します",
	"action.change_animation_speed": "アニメーションスピードを変更...",
	"action.change_animation_speed.desc": "アニメーションの再生速度を変更します",
	"timeline.select_particle_file": "パーティクルファイルを選択",
	"timeline.select_sound_file": "サウンドファイルを選択",
	"menu.cube.texture.default": "デフォルト",
	"menu.texture.particle.clear": "パーティクルを使用しない",
	"menu.texture.use_as_default": "デフォルトに設定",
	"menu.texture.use_as_default.clear": "デフォルトを解除",
	"menu.toolbar.overflow": "ツールバーフロー",
	"edit.solidify_mesh_selection.thickness": "ティックネス",
	"reference_image.sync_to_timeline": "タイムラインに同期",
	"reference_image.toggle_playback": "プレイ/ポーズ",
	"dialog.add_primitive.shape.beveled_cuboid": "Beveled Cuboid",
	"dialog.ignore_all": "すべて無視",
	"data.texture_group": "テクスチャグループ",
	"data.animation": "アニメーション",
	"generic.on": "On",
	"generic.off": "Off",
	"format.free.info.3d_printing": "3D プリント",
	"message.invalid_file.merge_conflict": "The file contains unresolved Git merge conflicts.",
	"dialog.expand_texture_selection.radius": "大きさ",
	"dialog.expand_texture_selection.corner": "コーナーシェイプ",
	"dialog.expand_texture_selection.corner.round": "角度",
	"dialog.expand_texture_selection.corner.square": "四角形",
	"dialog.expand_texture_selection.corner.manhattan": "マンハッタン",
	"dialog.merge_animation.merge_target": "マージ",
	"keybindings.variation_conflict": "Variation conflicts with the main keybinding",
	"settings.recovery_save_interval": "リカバリーポイント間隔",
	"settings.recovery_save_interval.desc": "Blockbench regularly saves the open project in the background to recover in case of a computer crash. Set the interval in seconds. Set to 0 to disable saving.",
	"settings.save_view_per_tab": "タブごとにビューを保存",
	"settings.save_view_per_tab.desc": "Save the current view angle for each tab separately",
	"settings.inherit_parent_color": "Inherit Parent Color",
	"settings.inherit_parent_color.desc": "Set the marker color of a newly created element to the color of the parent instead of a random color",
	"keybind.preview_select.multi_select": "選択-複数",
	"keybind.preview_select.group_select": "選択-グループ",
	"keybind.preview_select.loop_select": "選択-ループ",
	"action.fill_mode.selection": "選択",
	"action.fill_mode.selected_elements": "Selected Elements",
	"action.image_tiled_view": "タイル表示",
	"action.image_tiled_view.description": "2D エディタでタイル表示を有効にします",
	"action.image_onion_skin_view": "Image Editor Onion Skin",
	"action.image_onion_skin_view.description": "2D エディタでオニオンスキン表示を有効にします",
	"action.expand_texture_selection": "テクスチャ選択範囲の拡張",
	"action.expand_texture_selection.desc": "テクスチャの選択範囲を拡大または縮小します",
	"action.switch_tabs.reverse_order": "逆順",
	"action.save_project_incremental": "Increment プロジェクトを保存",
	"action.save_project_incremental.desc": "現在のモデルをプロジェクトファイルとしてインクリメント付きで保存します (ex: project_2.bbmodel)",
	"action.copy.multiple": "すべてコピー",
	"action.copy.multiple.desc": "利用可能なすべてのデータを個別にコピーします",
	"action.paste.multiple": "すべて貼り付け",
	"action.randomize_marker_colors": "ランダムなマーカーカラー",
	"action.cube_light_emission": "光源レベル",
	"action.cube_light_emission.desc": "選択したキューブの発光レベルを 0 ~ 15 の値で変更します,",
	"action.view_mode.colored_solid": "Solid with Marker Colors",
	"action.focus_on_selection.rotate_only": "ローテートのみ",
	"action.create_texture_group": "テクスチャグループを作成",
	"action.create_texture_group.desc": "テクスチャごとにグループを作成します",
	"action.uv_maximize.all_faces": "すべてのフェイスに適用",
	"action.retarget_animators": "アニメーションをリターゲット",
	"action.retarget_animators.desc": "アニメーターが新たにターゲットを再選択します",
	"action.merge_animation": "アニメーションをマージ",
	"action.merge_animation.desc": "アニメーションを別のアニメーションに結合します",
	"action.add_keyframe.reset_values": "デフォルト値",
	"action.set_timeline_range_start": "タイムラインの開始点を設定します",
	"action.set_timeline_range_start.desc": "アニメーションタイムラインで再生範囲の開始点を設定します",
	"action.set_timeline_range_end": "タイムラインの終点を設定します",
	"action.set_timeline_range_end.desc": "アニメーションタイムラインで再生範囲の終点を設定します",
	"action.disable_timeline_range": "タイムライン範囲を無効",
	"action.disable_timeline_range.desc": "アニメーションタイムラインのカスタム再生範囲を無効にします",
	"menu.texture_group.resolve": "確定",
	"menu.image_tiled_view.mirrored": "Mirrored Edges",
	"menu.image_onion_skin_view.frame": "フレーム",
	"menu.image_onion_skin_view.frame.last_viewed": "前回のフレーム",
	"menu.image_onion_skin_view.frame.previous": "前のフレーム",
	"menu.image_onion_skin_view.frame.next": "次のフレーム",
	"menu.image_onion_skin_view.frame.both": "比較",
	"menu.image_onion_skin_view.display": "表示",
	"menu.image_onion_skin_view.display.pixels": "Smaller Pixels",
	"menu.image_onion_skin_view.display.transparent": "透明",
	"menu.image_onion_skin_view.above": "上部に表示",
	"menu.animation.reload": "リロード",
	"switches.autouv.alt": "相対",
	"display.rotation_pivot": "ピボットローテーション",
	"display.scale_pivot": "ピボットスケール",
	"display.reference.fox": "キツネ",
	"display.reference.eating": "食べる",
	"preview_scene.sky": "空",
	"preview_scene.space": "スペース",
	"preview_scene.minecraft_ocean": "海",
	"message.import_palette.selection_only": "選択のみ",
	"dialog.blend_transition_edit.ease_in_out": "イーズインアウト (%0)",
	"dialog.blend_transition_edit.generate": "生成する...",
	"dialog.blend_transition_edit.generate.learn_more": "詳細情報とプレビュー",
	"dialog.blend_transition_edit.generate.curve": "イージングタイプ",
	"dialog.blend_transition_edit.generate.steps": "キーフレーム",
	"settings.fps_limit": "フレームレート",
	"settings.fps_limit.desc": "Blockbench が 1 秒あたりにレンダリングするフレーム数を制限します。実際のフレームレートは、お使いのデバイスによって変動します。",
	"settings.outliner_reveal_on_select": "エレメントをハイライト",
	"settings.outliner_reveal_on_select.desc": "選択されたエレメントをハイライト表示します",
	"settings.java_export_pivots": "java block/item をピボットでエクスポート",
	"settings.java_export_pivots.desc": "キューブ上の Java ブロック/アイテムモデルのピボットポイントを保存します",
	"animation_controllers.state.blend_transition_curve": "ブレンド遷移曲線",
	"menu.slider.reset_vector": "ベクトルをリセット",
	"dialog.blend_transition_edit.extended": "拡張グラフ",
	"message.screenshot_too_large.title": "スクリーンショット解像度エラー",
	"message.screenshot_too_large.message": "スクリーンショットがうまく表示されませんでした。解像度を下げるか、スーパーサンプリングをオフにして再度お試しください。",
	"message.rename_elements.numbering": "連番を生成する際に、特殊文字を活用することができます: % を使うと、グループのインデックスを取得でき、 $ を使うと、選択範囲のインデックスを取得することが出来ます。",
	"generic.edit_externally": "Edit Externally",
	"message.settings_require_restart.title": "再起動が必要です",
	"message.settings_require_restart.message": "一部の設定は、アプリを再起動したあとに適用されます。",
	"message.settings_require_restart.restart_now": "今すぐ再起動",
	"message.settings_require_restart.restart_later": "あとで再起動",
	"message.classroom_mode.install_plugin": "クラスルームモードではプラグインをインストールできません",
	"dialog.collection.export_path": "Export Path",
	"dialog.collection.select_all": "すべて選択",
	"dialog.collection.select_none": "Select None",
	"dialog.collection.add_with_filter": "Add with Filter",
	"dialog.collection.remove": "削除",
	"dialog.material_config.title": "Material Config",
	"dialog.material_config.color_value": "Color Value",
	"dialog.material_config.mer": "Metal-Emissive-Roughness",
	"dialog.material_config.mer_value": "MER Value",
	"dialog.material_config.depth_type": "Depth Type",
	"dialog.create_texture.disable_mirror_uv": "UV ミラーリングを無効",
	"dialog.create_texture.disable_mirror_uv.desc": "ミラーモデリングの UV ミラーオプションを無効にし、フェイスごとに個別の UV を保存します",
	"dialog.create_gif.turn.sync_to_anim_length": "Sync to animation length",
	"settings.category.controls": "コントロール",
	"settings.classroom_mode": "クラスルームモード",
	"settings.classroom_mode.desc": "Restricts functionality such as installing plugins and removes links to social media",
	"settings.antialiasing_bleed_fix": "Fix anti-aliasing bleeding",
	"settings.antialiasing_bleed_fix.desc": "Fixes texture bleeding when using anti-aliasing. Potentially unsupported on older hardware.",
	"settings.tone_mapping": "トーンマッピング",
	"settings.tone_mapping.desc": "PBR レンダリングにハイダイナミックレンジを表示します。",
	"settings.audio_scrubbing": "Timline Scrubbing Audio",
	"settings.audio_scrubbing.desc": "Play short previews of the audio while scrubbing through time timeline",
	"settings.viewport_rotate_speed": "ビューポート回転速度",
	"settings.viewport_rotate_speed.desc": "Input sensitivity when rotating in the viewport",
	"settings.viewport_zoom_speed": "ビューポートズーム速度",
	"settings.viewport_zoom_speed.desc": "Input sensitivity when zooming in the viewport",
	"settings.editor_2d_zoom_speed": "2D エディタのズーム速度",
	"settings.editor_2d_zoom_speed.desc": "UV および 2D ペイントエディタでズームするときの速度を変更します",
	"category.select": "Select",
	"action.vertex_snap_mode.rotate": "回転",
	"action.export_image": "画像をエクスポート",
	"action.export_image.desc": "Export your texture as an image file",
	"action.apply_mirror_modeling": "Apply Mirror Modeling",
	"action.apply_mirror_modeling.desc": "Apply Mirror Modeling to the selection. All selected elements will be copied and flipped across the X axis.",
	"action.create_collection": "Create Collection",
	"action.create_collection.desc": "Create a collection out of the outliner selection",
	"action.set_collection_content_to_selection": "Set Collection Content to Selected",
	"action.set_collection_content_to_selection.desc": "Set the selected groups and elements as the content of the collection",
	"action.add_to_collection": "Add Selected to Collection",
	"action.add_to_collection.desc": "Add the selected groups and elements to the collection",
	"action.view_mode.material": "マテリアルをプレビュー",
	"action.create_material": "マテリアルを作成",
	"action.create_material.desc": "Create a new PBR material out of the selected texture",
	"action.generate_pbr_map": "Generate PBR Map...",
	"action.generate_pbr_map.desc": "Generate a PBR map (height map or metalness, emissiveness, roughness) from an existing texture",
	"menu.tools.main_tools": "Toolbox",
	"menu.view.panels": "Panels",
	"menu.texture.pbr_channel": "PBR Channel",
	"menu.texture.pbr_channel.color": "Color",
	"menu.texture.pbr_channel.normal": "ノーマル",
	"menu.texture.pbr_channel.height": "Height",
	"menu.texture.pbr_channel.mer": "MER (Metalness-Emissive-Roughness)",
	"menu.texture.pbr_channel.mer_subsurface": "MER Subsurface",
	"menu.collection.export_project": "プロジェクトをエクスポート",
	"menu.collection.export_as": "Export as \"%0\"",
	"menu.panel.enable": "Enable",
	"menu.panel.move_to": "Move to",
	"menu.panel.move_to.left_bar": "Left Side",
	"menu.panel.move_to.right_bar": "Right Side",
	"menu.panel.move_to.top": "Top",
	"menu.panel.move_to.bottom": "Bottom",
	"menu.panel.move_to.float": "Float",
	"menu.panel.move_to.hidden": "Hide",
	"menu.panel.fold": "Collapse",
	"menu.mirror_painting.texture_center": "Origin",
	"menu.mirror_modeling.mirror_uv": "Mirror UV",
	"menu.animation_onion_skin.frames": "フレーム",
	"menu.animation_onion_skin.select": "選択",
	"menu.animation_onion_skin.previous": "前",
	"menu.animation_onion_skin.next": "次",
	"menu.animation_onion_skin.previous_next": "前 + 次",
	"menu.animation_onion_skin.count": "カウント",
	"menu.animation_onion_skin.interval": "インターバル",
	"menu.animation_onion_skin_selective": "Selective Onion Skin",
	"menu.animation_onion_skin_selective.desc": "Only display onion skin for the selected part of the model",
	"edit.loop_cut.unit": "ユニット",
	"edit.loop_cut.unit.size_units": "Size Units",
	"edit.loop_cut.unit.percent": "Percent",
	"edit.extrude_mesh_selection.direction": "方向",
	"edit.extrude_mesh_selection.direction.outwards": "外側",
	"edit.extrude_mesh_selection.direction.average": "平均",
	"edit.extrude_mesh_selection.even_extend": "Even Extend",
	"edit.vertex_snap.align": "整列",
	"edit.vertex_snap.align.longest": "Longest Axis",
	"edit.vertex_snap.align.direction": "Direction from Pivot",
	"edit.vertex_snap.align.align_axis": "%0 軸",
	"edit.vertex_snap.ignore_axis": "%0 軸を無視",
	"codec.common.format": "Format",
	"codec.image.quality": "クオリティ",
	"panel.collections": "Collections",
	"modifier_actions.always": "常に有効",
	"modifier_actions.unless": "%0 を除く",
	"settings.undo_selections": "巻き戻し選択",
	"settings.undo_selections.desc": "巻き戻した変更を、ステップごとに追跡します",
	"action.focus_on_selection.zoom": "ウィンドウにフィット",
	"display.reference.tooting": "角笛を吹く",
	"settings.selection_tolerance": "Selection Tolerance",
	"settings.selection_tolerance.desc": "Size of the area that can be clicked to select an edge or vertex",
	"action.delete.keep_vertices": "Keep Edges/Vertices",
	"menu.mesh": "メッシュ",
	"dialog.material_config.subsurface": "Subsurface Scattering",
	"dialog.material_config.subsurface_enabled.desc": "Use the MER map alpha channel for subsurface scattering",
	"settings.pick_combined_color": "Pick Combined Color",
	"settings.pick_combined_color.desc": "Pick the combined color of all layers at the respective pixel, instead of the color on the active layer",
	"action.split_rgb_into_layers": "Split RGB Channels into Layers",
	"action.split_rgb_into_layers.desc": "Split the texture into additive layers, one for each RGB channel"
}